import React, { useState, useEffect } from 'react';
import { useSpielgeldStore } from '../store/spielgeldStore.js';

// =====================================================================
// 🎨 NATIVE ICON COMPONENT (Keine externen Abhängigkeiten, Crash-sicher)
// =====================================================================
const Icon = ({ name, className }) => {
  const paths = {
    Smartphone: "M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z",
    Laptop: "M10 19l-2 3m8-3l2 3M3 19h18M5 15h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z",
    Percent: "M19 5L5 19M9 7a2 2 0 11-4 0 2 2 0 014 0zm10 10a2 2 0 11-4 0 2 2 0 014 0z",
    ShoppingBag: "M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z",
    Trash2: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16",
    AlertTriangle: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z",
    Plus: "M12 4v16m8-8H4",
    Wallet: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z",
    User: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z",
    Activity: "M13 10V3L4 14h7v7l9-11h-7z",
    CheckCircle2: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z",
    TrendingUp: "M13 7h8m0 0v8m0-8l-8 8-4-4-6 6",
    ArrowUpRight: "M7 17L17 7m0 0H8m9 0v9",
    ArrowDownRight: "M7 7l10 10m0 0H8m9 0V8",
    History: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z",
    CreditCard: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z",
    X: "M6 18L18 6M6 6l12 12",
    ChevronDown: "M19 9l-7 7-7-7",
    Settings: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z",
    Calendar: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z",
    Zap: "M13 2L3 14h9l-1 8 10-12h-9l1-8z",
    Euro: "M4 10h12M4 14h9m-5 6c-3.866 0-7-3.134-7-7s3.134-7 7-7c1.93 0 3.677.784 4.95 2.05",
    BarChart2: "M18 20V10M12 20V4M6 20v-6",
    Calculator: "M16 4H8a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V6a2 2 0 00-2-2z M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01M16 18h.01M8 10h8",
    PieChart: "M21.21 15.89A10 10 0 118 2.83M22 12A10 10 0 0012 2v10z",
    Briefcase: "M21 8a2 2 0 00-2-2h-3.92A2 2 0 0013 4h-2a2 2 0 00-2.08 2H5a2 2 0 00-2 2v10a2 2 0 002 2h14a2 2 0 002-2V8z M16 6a2 2 0 00-2-2h-4a2 2 0 00-2 2M8 14v-2M16 14v-2",
    ChevronLeft: "M15 19l-7-7 7-7",
    ChevronRight: "M9 5l7 7-7 7",
    ArrowRight: "M5 12h14M12 5l7 7-7 7",
    Printer: "M6 9V2h12v7M6 18H4a2 2 0 01-2-2v-5a2 2 0 012-2h16a2 2 0 012 2v5a2 2 0 01-2 2h-2M6 14h12v8H6v-8z",
    CupSoda: "M18 8h1a4 4 0 010 8h-1M2 8h16v9a4 4 0 01-4 4H6a4 4 0 01-4-4V8z M6 1v3M10 1v3M14 1v3", // Verwende ein Coffee/Drink Icon
    Minus: "M5 12h14",
    Check: "M5 13l4 4L19 7",
    Hash: "M4 9h16M4 15h16M10 3L8 21M16 3l-2 18"
  };

  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={paths[name] || paths.Smartphone} />
    </svg>
  );
};

// =====================================================================
// CSS-HELPER: Entfernt die hässlichen Pfeile aus allen Number-Inputs
// =====================================================================
const noSpinner = "[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none";

// =====================================================================
// 🎨 CSS-BASED REDBULL CAN (No external image needed, 100% crash-proof)
// =====================================================================
const RedbullCan = ({ className = "" }) => (
  <div className={`relative rounded-t-[10px] rounded-b-[10px] overflow-hidden shadow-[inset_-5px_0_15px_rgba(0,0,0,0.5),10px_10px_20px_rgba(0,0,0,0.5)] border-x border-white/30 bg-[#0A1B3F] ${className}`}>
    {/* Silberner Deckel */}
    <div className="absolute top-0 w-full h-[12%] bg-gradient-to-r from-gray-400 via-gray-100 to-gray-500 shadow-sm z-20">
      <div className="w-1/2 h-1 bg-gray-600/20 mx-auto mt-1 rounded-full"></div>
    </div>
    
    {/* Blauer/Silberner Body */}
    <div className="absolute top-[10%] bottom-[10%] w-full">
       {/* Schachbrett/Silber Diagonal */}
       <div className="absolute bottom-0 right-0 w-full h-[80%] bg-gradient-to-tr from-gray-300 via-white to-gray-400" style={{ clipPath: 'polygon(100% 0, 100% 100%, 0 100%)' }}></div>
       
       {/* Gelbe Sonne */}
       <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-[20%] w-[45%] aspect-square bg-gradient-to-br from-yellow-300 to-amber-500 rounded-full shadow-[0_0_10px_rgba(252,211,77,0.8)] z-10"></div>
       
       {/* Rote Bullen (Abstrahiert) */}
       <div className="absolute top-1/2 left-[15%] w-[30%] h-[15%] bg-red-600 rounded-l-full rounded-tr-full z-10" style={{ clipPath: 'polygon(0 50%, 100% 0, 80% 100%)' }}></div>
       <div className="absolute top-1/2 right-[15%] w-[30%] h-[15%] bg-red-600 rounded-r-full rounded-tl-full z-10" style={{ clipPath: 'polygon(100% 50%, 0 0, 20% 100%)' }}></div>

       {/* Red Bull Text */}
       <div className="absolute top-[15%] w-full text-center flex flex-col items-center justify-center z-10 drop-shadow-md">
         <span className="text-[0.45em] font-black text-red-600 tracking-[0.1em] leading-none mb-0.5" style={{ fontFamily: 'Arial, sans-serif' }}>Red Bull</span>
         <span className="text-[0.25em] font-bold text-blue-900 tracking-widest leading-none">ENERGY DRINK</span>
       </div>
    </div>
    
    {/* Silberner Boden */}
    <div className="absolute bottom-0 w-full h-[12%] bg-gradient-to-r from-gray-500 via-gray-200 to-gray-400 shadow-sm z-20"></div>
    
    {/* Glanz-Reflektion über die ganze Dose */}
    <div className="absolute inset-0 w-1/3 bg-gradient-to-r from-transparent via-white/40 to-transparent z-30 pointer-events-none"></div>
  </div>
);

const fmtEuro = (val) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(val || 0);

export function SpielgeldRechner({ isStandalone = true }) {
  const sessions = useSpielgeldStore(state => state.sessions) || [];
  const activeSessionId = useSpielgeldStore(state => state.activeSessionId);
  const globalBudget = useSpielgeldStore(state => state.globalBudget);
  const setGlobalBudget = useSpielgeldStore(state => state.setGlobalBudget);
  
  const calculateMonthlyWallet = useSpielgeldStore(state => state.calculateMonthlyWallet);
  const getActiveSession = useSpielgeldStore(state => state.getActiveSession);
  const calculateTotals = useSpielgeldStore(state => state.calculateTotals);
  const calculateSessionTotal = useSpielgeldStore(state => state.calculateSessionTotal);
  
  const addArticle = useSpielgeldStore(state => state.addArticle);
  const updateArticle = useSpielgeldStore(state => state.updateArticle);
  const removeArticle = useSpielgeldStore(state => state.removeArticle);
  
  const addTariff = useSpielgeldStore(state => state.addTariff);
  const updateTariff = useSpielgeldStore(state => state.updateTariff);
  const removeTariff = useSpielgeldStore(state => state.removeTariff);
  
  const addGetraenk = useSpielgeldStore(state => state.addGetraenk);
  const updateGetraenk = useSpielgeldStore(state => state.updateGetraenk);
  const removeGetraenk = useSpielgeldStore(state => state.removeGetraenk);
  
  const updateActiveSession = useSpielgeldStore(state => state.updateActiveSession);
  const createNewSession = useSpielgeldStore(state => state.createNewSession);
  const switchSession = useSpielgeldStore(state => state.switchSession);
  const deleteSession = useSpielgeldStore(state => state.deleteSession);
  
  const topUps = useSpielgeldStore(state => state.topUps) || [];
  const addTopUp = useSpielgeldStore(state => state.addTopUp);
  const removeTopUp = useSpielgeldStore(state => state.removeTopUp);
  const defaultRedbullPreis = useSpielgeldStore(state => state.defaultRedbullPreis);
  const setDefaultRedbullPreis = useSpielgeldStore(state => state.setDefaultRedbullPreis);

  // Märkte (dynamisch)
  const markets = useSpielgeldStore(state => state.markets || []);
  const fetchMarkets = useSpielgeldStore(state => state.fetchMarkets);
  
  // Katalog
  const dbTariffs = useSpielgeldStore(state => state.dbTariffs || []);
  const dbOptions = useSpielgeldStore(state => state.dbOptions || []);

  const initFromDB = useSpielgeldStore(state => state.initFromDB);

  useEffect(() => {
    if (fetchMarkets) fetchMarkets();
    if (initFromDB) initFromDB();
  }, [fetchMarkets, initFromDB]);

  const [calcMode, setCalcMode] = useState('smartphone');
  const [selectedMarkt, setSelectedMarkt] = useState('Media Markt Erfurt 1');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  
  const [trigger, setTrigger] = useState(0);
  
  const [isSettingsOpen, setIsSettingsOpen] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('tefcms_settings_open') === 'true';
    }
    return false;
  });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('tefcms_settings_open', isSettingsOpen);
    }
  }, [isSettingsOpen]);
  const [dashboardOpen, setDashboardOpen] = useState(false);
  const [chartModalOpen, setChartModalOpen] = useState(false);
  const [reportModalOpen, setReportModalOpen] = useState(false);
  const [reportFilter, setReportFilter] = useState('HEUTE');
  const [sessionToDelete, setSessionToDelete] = useState(null);
  const [resetModalOpen, setResetModalOpen] = useState(false);
  const [resetCode, setResetCode] = useState('');
  const [resetTargetCode, setResetTargetCode] = useState('');
  const [isShaking, setIsShaking] = useState(false);
  const [dashboardFilter, setDashboardFilter] = useState('TAG');
  const [dashboardOffset, setDashboardOffset] = useState(0);
  const [rechnerDate, setRechnerDate] = useState(new Date());
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [calendarMonthOffset, setCalendarMonthOffset] = useState(0);
  const [tempTopUpAmount, setTempTopUpAmount] = useState('');
  const [tempTopUpDesc, setTempTopUpDesc] = useState('');

  // Redbull Dosen-Rechner
  const [doseCalcBrutto, setDoseCalcBrutto] = useState('');

  const activeSession = sessions.find(s => s.id === activeSessionId) || getActiveSession() || {};
  const totals = calculateTotals();
  const wallet = calculateMonthlyWallet();

  const today = rechnerDate;
  const dateString = today.toLocaleDateString('de-DE', { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' });

  // TESTDATEN GENERIEREN
  const generateTestData = () => {
    const testSessions = [];
    const now = new Date();

    // Session von HEUTE
    testSessions.push({
      id: `test-heute-${Date.now()}`,
      name: 'Max Mustermann (Heute)',
      kundenName: 'Max Mustermann',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      articles: [{ id: 'a1', name: 'iPhone 15 Pro', preis: '1100', inputMode: 'brutto' }],
      tariffs: [],
      hardwareZuschussBrutto: '',
      pushNetto: '',
      pushBrutto: '',
      redbullNetto: '',
      getraenkNetto: '',
      individuellNetto: ''
    });

    // Session von dieser WOCHE (vor 3 Tagen)
    const vor3Tagen = new Date(now);
    vor3Tagen.setDate(now.getDate() - 3);
    testSessions.push({
      id: `test-woche-${Date.now()}`,
      name: 'Anna Schmidt (Woche)',
      kundenName: 'Anna Schmidt',
      createdAt: vor3Tagen.toISOString(),
      updatedAt: vor3Tagen.toISOString(),
      articles: [],
      tariffs: [{ id: 't1', name: 'O2 Mobile M', couponBrutto: '10', couponErhohungBrutto: '5' }],
      hardwareZuschussBrutto: '',
      pushNetto: '',
      pushBrutto: '',
      redbullNetto: '',
      getraenkNetto: '',
      individuellNetto: ''
    });

    // Session von diesem MONAT (vor 15 Tagen)
    const vor15Tagen = new Date(now);
    vor15Tagen.setDate(now.getDate() - 15);
    testSessions.push({
      id: `test-monat-${Date.now()}`,
      name: 'Tom Becker (Monat)',
      kundenName: 'Tom Becker',
      createdAt: vor15Tagen.toISOString(),
      updatedAt: vor15Tagen.toISOString(),
      articles: [{ id: 'a2', name: 'Samsung S24', preis: '900', inputMode: 'brutto' }],
      tariffs: [],
      hardwareZuschussBrutto: '150',
      pushNetto: '',
      pushBrutto: '',
      redbullNetto: '',
      getraenkNetto: '',
      individuellNetto: ''
    });

    // Session von diesem JAHR (vor 60 Tagen)
    const vor60Tagen = new Date(now);
    vor60Tagen.setDate(now.getDate() - 60);
    testSessions.push({
      id: `test-jahr-${Date.now()}`,
      name: 'Lisa Mayer (Jahr)',
      kundenName: 'Lisa Mayer',
      createdAt: vor60Tagen.toISOString(),
      updatedAt: vor60Tagen.toISOString(),
      articles: [],
      tariffs: [],
      hardwareZuschussBrutto: '',
      pushNetto: '50',
      pushBrutto: '',
      redbullNetto: '2.50',
      getraenkNetto: '',
      individuellNetto: ''
    });

    // Alle in den Store pushen
    useSpielgeldStore.setState((state) => ({
      sessions: [...testSessions, ...state.sessions]
    }));
    setTrigger(t => t + 1);
  };

  const getUsedForInterval = (interval) => {
    const now = new Date();
    return sessions.filter(s => {
      const d = new Date(s.createdAt);
      if (interval === 'TAG') {
        return d.toDateString() === now.toDateString();
      } else if (interval === 'KALENDERWOCHE') {
        const day = now.getDay() || 7; 
        const startOfWeek = new Date(now);
        startOfWeek.setHours(0,0,0,0);
        startOfWeek.setDate(now.getDate() - day + 1);
        return d >= startOfWeek;
      } else if (interval === 'MONAT') {
        return d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear();
      } else if (interval === 'JAHR') {
        return d.getFullYear() === now.getFullYear();
      }
      return true;
    }).reduce((sum, s) => sum + (calculateSessionTotal ? calculateSessionTotal(s) : 0), 0);
  };

  const usedHeute = getUsedForInterval('TAG');
  const usedWoche = getUsedForInterval('KALENDERWOCHE');
  const usedMonat = getUsedForInterval('MONAT');
  const usedJahr = getUsedForInterval('JAHR');

  const usedGetraenkeMonatObj = sessions.filter(s => {
    const d = new Date(s.createdAt);
    const now = new Date();
    return d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear();
  }).reduce((acc, s) => {
    let anzahl = 0;
    let brutto = 0;
    let netto = 0;
    let contracts = 0;

    // Neue Struktur (getraenkeList)
    if (s.getraenkeList && Array.isArray(s.getraenkeList)) {
      s.getraenkeList.forEach(g => {
        const qty = parseInt(g.anzahl) || 1;
        anzahl += qty;
        if (g.netto) netto += parseFloat(g.netto);
        if (g.brutto) brutto += parseFloat(g.brutto);
        if (g.contractSigned) contracts += qty;
      });
    }

    // Legacy Struktur
    if (s.getraenkeAnzahl) anzahl += parseInt(s.getraenkeAnzahl, 10);
    if (s.getraenkeBrutto) brutto += parseFloat(s.getraenkeBrutto);
    else if (s.getraenkeNetto) brutto += parseFloat(s.getraenkeNetto) * 1.19;

    if (s.getraenkeNetto) netto += parseFloat(s.getraenkeNetto);
    else if (s.getraenkeBrutto) netto += parseFloat(s.getraenkeBrutto) / 1.19;

    if (s.redbullNetto) {
      netto += parseFloat(s.redbullNetto);
      brutto += parseFloat(s.redbullNetto) * 1.19;
      if (!s.getraenkeAnzahl) anzahl += 1; 
    }

    return { 
      anzahl: acc.anzahl + anzahl, 
      netto: acc.netto + netto, 
      brutto: acc.brutto + brutto,
      contracts: acc.contracts + contracts
    };
  }, { anzahl: 0, netto: 0, brutto: 0, contracts: 0 });

  const displayUsedAllSessions = usedMonat;
  const displayCurrentBalance = wallet.totalAvailable - displayUsedAllSessions;
  const displayPercent = Math.max(0, Math.min(wallet.totalAvailable > 0 ? (displayUsedAllSessions / wallet.totalAvailable) * 100 : 0, 100));

  // Für das Donut Chart
  const radius = 35; // Etwas kompakter
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (displayPercent / 100) * circumference;

  const hasTopUp = wallet.totalTopUps > 0;
  
  // 🎨 Neuer Farbverlauf Logik
  const getUsageColorClass = (percent) => {
    if (percent === 0) return 'text-emerald-500';
    if (percent < 25) return 'text-emerald-400';
    if (percent < 50) return 'text-yellow-400';
    if (percent < 75) return 'text-orange-500';
    if (percent < 90) return 'text-rose-500';
    return 'text-rose-600';
  };
  
  const getUsageColorHex = (percent) => {
    if (percent === 0) return '#10b981';
    if (percent < 25) return '#34d399';
    if (percent < 50) return '#facc15';
    if (percent < 75) return '#f97316';
    if (percent < 90) return '#f43f5e';
    return '#e11d48';
  };

  const usageColorClass = getUsageColorClass(displayPercent);
  const usageColorHex = getUsageColorHex(displayPercent);

  // ==========================================
  // TOP DASHBOARD (Das Monats-Wallet)
  // ==========================================
  const renderWalletDashboard = () => (
    <div className={`w-full max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 pt-8 pb-8 relative z-40`}>
      
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8 animate-in fade-in slide-in-from-top-4 duration-700 relative z-50">
        <div 
          onClick={() => { setCalendarMonthOffset(0); setCalendarOpen(true); }}
          className="flex items-center gap-3 bg-white/[0.03] backdrop-blur-2xl border border-white/[0.08] hover:bg-white/[0.06] hover:border-cyan-500/30 hover:shadow-[0_0_20px_rgba(34,212,238,0.2)] px-5 py-2.5 rounded-full shadow-[inset_0_1px_0_rgba(255,255,255,0.2),0_10px_20px_rgba(0,0,0,0.3)] transition-all duration-300 cursor-pointer group"
        >
          <Icon name="Calendar" className="w-4 h-4 text-cyan-400 group-hover:scale-110 transition-transform" />
          <span className="text-cyan-400 font-bold uppercase tracking-widest text-[0.65rem] drop-shadow-[0_0_8px_rgba(34,212,238,0.4)]">{dateString}</span>
        </div>
        
        <button 
          onClick={() => setIsSettingsOpen(true)}
          className="flex items-center gap-3 bg-white/[0.03] backdrop-blur-2xl border border-white/[0.08] hover:bg-white/[0.06] hover:border-white/[0.12] px-6 py-2.5 rounded-full shadow-[inset_0_1px_0_rgba(255,255,255,0.2),0_10px_20px_rgba(0,0,0,0.3)] transition-all group cursor-pointer"
        >
          <Icon name="Settings" className="w-4 h-4 text-slate-400 group-hover:text-cyan-400 transition-colors" />
          <span className="text-[0.65rem] text-slate-300 group-hover:text-cyan-400 uppercase tracking-widest font-bold transition-colors">Budget Settings</span>
        </button>
      </div>

      {/* TRUE LIQUID GLASS DASHBOARD PANEL */}
      <div className="bg-white/[0.03] backdrop-blur-3xl border border-white/[0.08] rounded-[2rem] p-8 md:p-12 shadow-[inset_0_1px_0_rgba(255,255,255,0.2),0_25px_50px_-12px_rgba(0,0,0,0.5)] relative z-10">
        
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6 mb-16 relative z-50">
          <div 
            className="relative group/dropdown focus:outline-none"
            tabIndex={0}
            onBlur={(e) => {
              if (!e.currentTarget.contains(e.relatedTarget)) {
                setIsDropdownOpen(false);
              }
            }}
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          >
            {/* Premium Modern Dropdown */}
            <div className="flex items-center justify-between bg-white/[0.03] backdrop-blur-2xl border border-white/[0.08] hover:bg-white/[0.06] hover:border-white/[0.15] rounded-full py-3 px-6 min-w-[320px] cursor-pointer shadow-[inset_0_1px_0_rgba(255,255,255,0.2)] transition-all duration-300">
              <span className="text-[0.65rem] font-bold text-slate-200 uppercase tracking-[0.2em] flex items-center gap-3">
                <span className="relative flex h-2 w-2">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-cyan-400 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-cyan-500"></span>
                </span>
                {selectedMarkt}
              </span>
              <Icon name="ChevronDown" className={`w-4 h-4 text-slate-400 transition-transform duration-300 ${isDropdownOpen ? 'rotate-180' : ''}`} />
            </div>
            
            {/* Dropdown Menu (Sleek Glassmorphism) */}
            {isDropdownOpen && (
              <div className="absolute top-[calc(100%+8px)] left-0 w-full bg-[#0a0f19]/95 backdrop-blur-3xl border border-white/10 rounded-2xl shadow-[0_20px_60px_-15px_rgba(0,0,0,0.7)] overflow-hidden animate-in fade-in slide-in-from-top-2 duration-200">
                <div className="p-1.5">
                  <div 
                    className="px-4 py-3.5 rounded-[14px] flex items-center justify-between cursor-pointer bg-white/[0.04] transition-colors"
                    onClick={(e) => { e.stopPropagation(); setSelectedMarkt('Media Markt Erfurt 1'); setIsDropdownOpen(false); }}
                  >
                    <span className="text-[0.65rem] font-bold text-cyan-400 uppercase tracking-[0.2em]">Media Markt Erfurt 1</span>
                    <Icon name="Check" className="w-4 h-4 text-cyan-400" />
                  </div>
                  
                  {/* Placeholder für zukünftige API-Daten */}
                  <div className="px-4 py-3.5 rounded-[14px] flex items-center justify-between cursor-not-allowed opacity-30">
                    <span className="text-[0.6rem] text-slate-400 font-bold uppercase tracking-[0.1em]">Weitere Standorte laden...</span>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Filter buttons removed based on new design - replaced by sub-areas below */}
        </div>

        {/* ROW 2: Zahlen & Grafiken (Kreis ist jetzt rechts!) */}
        <div className="flex flex-col lg:flex-row justify-between lg:items-end gap-12 relative z-10 mb-10">
          
          <div className="flex flex-col">
            <div className="text-slate-400 text-[0.65rem] uppercase tracking-[0.25em] font-bold mb-2 flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-cyan-400 shadow-[0_0_8px_rgba(34,212,238,1)] animate-pulse" />
              Verfügbares Restbudget <span className="text-cyan-500 ml-1">(NETTO)</span>
              {hasTopUp && <span className="ml-2 px-2 py-0.5 rounded-full bg-fuchsia-500/10 border border-fuchsia-500/30 text-fuchsia-400 text-[0.5rem] tracking-widest animate-pulse shadow-[0_0_10px_rgba(217,70,239,0.2)]">+ EXTRA BUDGET</span>}
            </div>
            <div className="text-6xl md:text-7xl font-black text-white tracking-tighter font-mono flex items-baseline gap-4 mb-2">
              {fmtEuro(displayCurrentBalance).replace('€', '').trim()} 
              <span className="text-5xl">€</span>
            </div>
            <div className="text-[0.65rem] font-bold uppercase tracking-widest text-slate-500">
              Brutto: <span className="text-cyan-500/80">{fmtEuro(displayCurrentBalance * 1.19)}</span>
            </div>
          </div>

          {/* RECHTER BEREICH: Ausgegeben + eleganter Donut Chart */}
          <div className="flex items-center gap-6">
            <div className="flex flex-col lg:items-end">
              <div className="text-slate-500 text-[0.65rem] uppercase tracking-[0.25em] font-bold mb-2 flex items-center gap-2">
                <Icon name="TrendingUp" className={`w-3 h-3 transition-colors duration-1000 ${usageColorClass}`} />
                Ausgegeben <span className={`ml-1 transition-colors duration-1000 ${usageColorClass}`}>(NETTO)</span>
              </div>
              <div 
                className={`text-4xl md:text-5xl font-black tracking-tighter font-mono flex items-baseline gap-3 mb-2 transition-colors duration-1000 ${usageColorClass}`} 
                style={{ filter: `drop-shadow(0 0 15px ${usageColorHex}33)` }}
              >
                {fmtEuro(displayUsedAllSessions).replace('€', '').trim()} 
                <span className="text-4xl">€</span>
              </div>
              <div className="text-[0.65rem] font-bold uppercase tracking-widest text-slate-500">
                Brutto: <span className={`transition-colors duration-1000 ${usageColorClass}`} style={{ opacity: 0.8 }}>{fmtEuro(displayUsedAllSessions * 1.19)}</span>
              </div>
            </div>

            {/* 🚀 NEU: Die animierte Ring-Grafik elegant rechts eingebaut (jetzt klickbar!) */}
            <div 
              className="relative w-20 h-20 flex-shrink-0 transition-all duration-500 cursor-pointer hover:scale-110 group" 
              style={{ filter: `drop-shadow(0 0 15px ${usageColorHex}4D)` }}
              onClick={() => setChartModalOpen(true)}
            >
              <div className="absolute -inset-2 bg-white/5 rounded-full opacity-0 group-hover:opacity-100 transition-opacity blur-md"></div>
              <svg viewBox="0 0 100 100" className="w-full h-full transform -rotate-90 relative z-10">
                <circle cx="50" cy="50" r="35" fill="none" stroke="#160810" strokeWidth="5" />
                <circle 
                  cx="50" cy="50" r="35" fill="none" 
                  stroke={usageColorHex} 
                  strokeWidth="5"
                  strokeDasharray={circumference} 
                  strokeDashoffset={strokeDashoffset} 
                  strokeLinecap="round" 
                  className="transition-all duration-1000 ease-out"
                />
              </svg>
              <div className="absolute inset-0 flex flex-col items-center justify-center z-10">
                <span className={`text-sm font-black transition-colors duration-1000 ${usageColorClass}`}>{displayPercent.toFixed(0)}%</span>
              </div>
            </div>
          </div>
        </div>

        {/* Eleganter Fortschrittsbalken mit viel Abstand */}
        <div className="w-full relative z-10 pt-6 pb-12">
          <style>{`
            @keyframes shimmer-move {
              0% { transform: translateX(-150%) skewX(-20deg); }
              100% { transform: translateX(300%) skewX(-20deg); }
            }
            .animate-shimmer-bar {
              animation: shimmer-move 3s infinite linear;
            }
            @keyframes stripe-move {
              0% { background-position: 0 0; }
              100% { background-position: 30px 0; }
            }
            .animate-stripes {
              background-image: repeating-linear-gradient(
                -45deg,
                rgba(255,255,255,0.1),
                rgba(255,255,255,0.1) 15px,
                transparent 15px,
                transparent 30px
              );
              background-size: 30px 30px;
              animation: stripe-move 1s linear infinite;
            }
          `}</style>
          
          <div className="w-full h-3.5 bg-[#05080c] border border-white/5 rounded-full overflow-hidden shadow-[inset_0_2px_8px_rgba(0,0,0,0.8)] relative">
            <div 
              className="h-full rounded-full transition-all duration-1000 ease-out relative overflow-hidden" 
              style={{ width: `${100 - displayPercent}%`, backgroundColor: usageColorHex }}
            >
              {/* 🚀 Animierte Streifen für permanente Bewegung */}
              <div className="absolute inset-0 animate-stripes"></div>
              
              <div className="absolute top-0 bottom-0 w-[40%] bg-gradient-to-r from-transparent via-white/40 to-transparent animate-shimmer-bar"></div>
              {(100 - displayPercent) > 0 && <div className="absolute right-0 top-1/2 -translate-y-1/2 w-4 h-4 bg-white/80 blur-[2px] rounded-full shadow-[0_0_15px_rgba(255,255,255,1)]"></div>}
            </div>
          </div>
        </div>

        {/* UNTERBEREICHE: Tag, KW, Monat, Jahr (True Liquid Glass) */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 relative z-10 w-full mt-2">
          <div 
            onClick={() => { setDashboardFilter('TAG'); setDashboardOffset(0); setDashboardOpen(true); }}
            className="bg-white/[0.03] backdrop-blur-2xl hover:bg-white/[0.06] cursor-pointer border border-white/[0.08] hover:border-white/[0.12] rounded-2xl p-4 flex flex-col justify-center items-center shadow-[inset_0_1px_0_rgba(255,255,255,0.2),0_10px_20px_rgba(0,0,0,0.4)] relative overflow-hidden group transition-all duration-300"
          >
            <span className="text-[0.55rem] text-slate-400 uppercase tracking-widest font-bold mb-1 group-hover:text-cyan-400 transition-colors relative z-10">Heute</span>
            <span className="text-xl font-black font-mono text-white relative z-10">{fmtEuro(usedHeute)}</span>
          </div>
          
          <div 
            onClick={() => { setDashboardFilter('KALENDERWOCHE'); setDashboardOffset(0); setDashboardOpen(true); }}
            className="bg-white/[0.03] backdrop-blur-2xl hover:bg-white/[0.06] cursor-pointer border border-white/[0.08] hover:border-white/[0.12] rounded-2xl p-4 flex flex-col justify-center items-center shadow-[inset_0_1px_0_rgba(255,255,255,0.2),0_10px_20px_rgba(0,0,0,0.4)] relative overflow-hidden group transition-all duration-300"
          >
            <span className="text-[0.55rem] text-slate-400 uppercase tracking-widest font-bold mb-1 group-hover:text-cyan-400 transition-colors relative z-10">Kalenderwoche</span>
            <span className="text-xl font-black font-mono text-white relative z-10">{fmtEuro(usedWoche)}</span>
          </div>
          
          <div 
            onClick={() => { setDashboardFilter('MONAT'); setDashboardOffset(0); setDashboardOpen(true); }}
            className="bg-cyan-500/[0.05] backdrop-blur-2xl hover:bg-cyan-500/[0.08] cursor-pointer border border-cyan-400/[0.15] hover:border-cyan-400/[0.25] rounded-2xl p-4 flex flex-col justify-center items-center shadow-[inset_0_1px_0_rgba(34,212,238,0.3),0_10px_20px_rgba(0,0,0,0.4)] relative overflow-hidden group transition-all duration-300"
          >
            <span className="text-[0.55rem] text-cyan-400 uppercase tracking-widest font-bold mb-1 flex items-center gap-1 group-hover:text-cyan-300 transition-colors relative z-10"><Icon name="CheckCircle2" className="w-3 h-3" /> Dieser Monat</span>
            <span className="text-xl font-black font-mono text-cyan-300 relative z-10">{fmtEuro(usedMonat)}</span>
          </div>
          
          <div 
            onClick={() => { setDashboardFilter('JAHR'); setDashboardOffset(0); setDashboardOpen(true); }}
            className="bg-white/[0.03] backdrop-blur-2xl hover:bg-white/[0.06] cursor-pointer border border-white/[0.08] hover:border-white/[0.12] rounded-2xl p-4 flex flex-col justify-center items-center shadow-[inset_0_1px_0_rgba(255,255,255,0.2),0_10px_20px_rgba(0,0,0,0.4)] relative overflow-hidden group transition-all duration-300"
          >
            <span className="text-[0.55rem] text-slate-400 uppercase tracking-widest font-bold mb-1 group-hover:text-cyan-400 transition-colors relative z-10">Dieses Jahr</span>
            <span className="text-xl font-black font-mono text-white relative z-10">{fmtEuro(usedJahr)}</span>
          </div>
        </div>
        
      </div>
    </div>
  );

  // ==========================================
  // RECHNER VIEW (Kompakt & Aufgeräumt)
  // ==========================================
  const modes = [
    { id: 'smartphone', icon: 'Smartphone', label: 'Smartphone' },
    { id: 'technik', icon: 'Laptop', label: 'Technik' },
    { id: 'nurtarif', icon: 'Percent', label: 'Nur Tarif' },
    { id: 'zusatzartikel', icon: 'ShoppingBag', label: 'Zusatz & Push' },
  ];

  const renderRechnerView = () => (
    <div className="w-full max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 pb-16 relative z-10">
      
      <div className="flex justify-between items-end mb-6 px-2">
        <div className="text-cyan-400 font-bold uppercase tracking-[0.2em] text-[0.65rem] flex items-center gap-2">
          <Icon name="Activity" className="w-3 h-3" /> Aktuelle Berechnung
        </div>
        <button onClick={createNewSession} className="bg-transparent border border-cyan-500/30 text-cyan-400 hover:bg-cyan-500/10 text-[0.55rem] font-bold uppercase tracking-widest px-4 py-1.5 rounded-full transition-all flex items-center gap-2">
          <Icon name="Plus" className="w-3 h-3" /> Neuer Kunde
        </button>
      </div>

      <div className="bg-white/[0.03] backdrop-blur-3xl border border-white/[0.08] rounded-[2rem] p-6 md:p-10 shadow-[inset_0_1px_0_rgba(255,255,255,0.2),0_25px_50px_-12px_rgba(0,0,0,0.5)] flex flex-col xl:flex-row gap-8 relative z-10">
        
        {/* Links: Kompakte Formulare */}
        <div className="flex-1 flex flex-col gap-4">
          
          <div className="flex flex-col md:flex-row items-end gap-4 mb-6 w-full">
            <div className="relative group w-full">
              <label className="text-[0.55rem] uppercase tracking-widest text-cyan-400 font-bold mb-2 block pl-1">Kundenname / ID</label>
              <input 
                type="text" 
                value={activeSession.kundenName || ''} 
                onChange={(e) => { 
                  updateActiveSession({ kundenName: e.target.value, name: e.target.value || 'Neue Berechnung' });
                  setTrigger(t => t + 1);
                }}
                className="bg-black/20 border border-cyan-500/20 rounded-xl px-4 py-3 text-lg font-bold text-cyan-300 placeholder-cyan-500/50 outline-none w-full focus:border-cyan-400/60 focus:shadow-[0_0_15px_rgba(34,212,238,0.2)] transition-all shadow-inner" 
                placeholder="Name eintragen..."
              />
            </div>
          </div>

          <div className="flex w-full bg-black/20 border border-white/10 rounded-xl p-1.5 mb-6 shadow-[inset_0_1px_0_rgba(255,255,255,0.05),inset_0_2px_10px_rgba(0,0,0,0.5)] overflow-x-auto hide-scrollbar backdrop-blur-md">
            {modes.map(m => {
              const isActive = calcMode === m.id;
              return (
                <button
                  key={m.id}
                  onClick={() => setCalcMode(m.id)}
                  className={`flex-1 flex items-center justify-center gap-3 px-4 py-3.5 rounded-lg text-[0.65rem] font-bold uppercase tracking-widest transition-all duration-300 whitespace-nowrap ${
                    isActive 
                    ? 'bg-white/10 text-cyan-400 shadow-[inset_0_1px_0_rgba(255,255,255,0.2)]' 
                    : 'text-white/70 hover:text-white hover:bg-white/[0.05]'
                  }`}
                >
                  <Icon name={m.icon} className="w-4 h-4" />
                  {m.label}
                </button>
              );
            })}
          </div>

          {/* DYNAMISCHE LISTEN */}
          <div className="min-h-[180px]">
            
            {(calcMode === 'smartphone' || calcMode === 'technik') && (
              <div className="flex flex-col gap-2 animate-in fade-in duration-500">
                {activeSession.articles?.map((article) => (
                  <div key={article.id} className="flex items-center gap-4 bg-white/[0.02] border border-white/[0.05] hover:bg-white/[0.04] hover:border-white/10 rounded-xl p-3 pr-4 group transition-colors">
                    <div className="flex-1">
                      <input 
                        type="text" value={article.name} 
                        onChange={(e) => { updateArticle(article.id, { name: e.target.value }); setTrigger(t => t + 1); }}
                        className="w-full bg-transparent text-sm text-white font-bold outline-none placeholder-white/50" placeholder="Gerätebezeichnung (z.B. iPhone 15)" 
                      />
                    </div>
                    <div className="w-24 relative">
                      <input 
                        type="number" step="0.01" min="0" value={article.preis} 
                        onChange={(e) => { updateArticle(article.id, { preis: e.target.value }); setTrigger(t => t + 1); }}
                        className={`w-full bg-transparent text-base text-white font-black font-mono outline-none text-right pr-4 ${noSpinner}`} placeholder="0.00" 
                      />
                      <span className="absolute right-0 top-0.5 text-white/50 font-mono text-sm">€</span>
                    </div>
                    <button onClick={() => { removeArticle(article.id); setTrigger(t => t + 1); }} className="text-white/50 hover:text-rose-400 transition-colors opacity-0 group-hover:opacity-100 flex-shrink-0">
                      <Icon name="Trash2" className="w-4 h-4" />
                    </button>
                  </div>
                ))}
                
                {/* 🚀 NEU: Eleganter "Dashed Dropzone" Hinzufügen-Button */}
                <button 
                  onClick={() => { addArticle({ id: Date.now().toString(), name: '', preis: '' }); setTrigger(t => t + 1); }}
                  disabled={(activeSession.articles?.length || 0) >= 6}
                  className="w-full mt-4 py-5 rounded-xl border-2 border-dashed border-white/10 bg-white/[0.02] hover:bg-cyan-500/10 hover:border-cyan-500/30 transition-all flex flex-col items-center justify-center gap-3 group backdrop-blur-sm"
                >
                  <div className="w-8 h-8 rounded-full bg-white/5 border border-white/10 flex items-center justify-center group-hover:bg-cyan-500/20 group-hover:border-cyan-500/30 transition-all">
                    <Icon name="Plus" className="w-4 h-4 text-white/70 group-hover:text-cyan-400 transition-colors" />
                  </div>
                  <span className="text-[0.65rem] font-bold uppercase tracking-widest text-white/70 group-hover:text-cyan-400 transition-colors">Weiteres Gerät hinzufügen</span>
                </button>
              </div>
            )}

            {calcMode === 'nurtarif' && (
              <div className="flex flex-col gap-2 animate-in fade-in duration-500">
                {activeSession.tariffs?.map((t) => (
                  <div key={t.id} className="flex flex-col md:flex-row md:items-center gap-4 bg-white/[0.02] border border-white/[0.05] hover:bg-white/[0.04] hover:border-white/10 rounded-xl p-3 pr-4 group transition-colors">
                    <div className="flex-1">
                      <input 
                        type="text" list="tariffs-list" value={t.name} 
                        onChange={(e) => { 
                          const val = e.target.value;
                          const found = dbTariffs.find(dt => (dt.title || dt.name) === val);
                          if (found) {
                            updateTariff(t.id, { name: val, couponBrutto: found.price || 0 });
                          } else {
                            updateTariff(t.id, { name: val }); 
                          }
                          setTrigger(tr => tr + 1); 
                        }}
                        className="w-full bg-transparent text-sm text-white font-bold outline-none placeholder-white/50" placeholder="Tarif aus Datenbank suchen oder eintippen..." 
                      />
                    </div>
                    <div className="flex items-center gap-6">
                      <div className="w-24 relative flex flex-col items-end">
                        <label className="text-[0.45rem] text-cyan-500/70 uppercase tracking-widest font-bold mb-1 pr-4">Coupon</label>
                        <div className="relative w-full">
                          <input type="number" step="0.01" min="0" value={t.couponBrutto} onChange={(e) => { updateTariff(t.id, { couponBrutto: e.target.value }); setTrigger(tr => tr + 1); }} className={`w-full bg-transparent text-base text-white font-black font-mono outline-none text-right pr-4 ${noSpinner}`} placeholder="0.00" />
                          <span className="absolute right-0 top-0.5 text-white/50 font-mono text-sm">€</span>
                        </div>
                      </div>
                      <div className="w-24 relative flex flex-col items-end">
                        <label className="text-[0.45rem] text-cyan-500/70 uppercase tracking-widest font-bold mb-1 pr-4">Erhöhung</label>
                        <div className="relative w-full">
                          <input type="number" step="0.01" min="0" value={t.couponErhohungBrutto} onChange={(e) => { updateTariff(t.id, { couponErhohungBrutto: e.target.value }); setTrigger(tr => tr + 1); }} className={`w-full bg-transparent text-base text-white font-black font-mono outline-none text-right pr-4 ${noSpinner}`} placeholder="0.00" />
                          <span className="absolute right-0 top-0.5 text-white/50 font-mono text-sm">€</span>
                        </div>
                      </div>
                      <button onClick={() => { removeTariff(t.id); setTrigger(tr => tr + 1); }} className="text-white/50 hover:text-rose-400 transition-colors opacity-0 group-hover:opacity-100 flex-shrink-0 mt-3 md:mt-0">
                        <Icon name="Trash2" className="w-4 h-4" />
                      </button>
                    </div>
                  </div>
                ))}
                
                {/* 🚀 NEU: Eleganter "Dashed Dropzone" Hinzufügen-Button */}
                <button 
                  onClick={() => { addTariff(); setTrigger(tr => tr + 1); }}
                  disabled={(activeSession.tariffs?.length || 0) >= 4}
                  className="w-full mt-4 py-5 rounded-xl border-2 border-dashed border-white/10 bg-white/[0.02] hover:bg-cyan-500/10 hover:border-cyan-500/30 transition-all flex flex-col items-center justify-center gap-3 group backdrop-blur-sm"
                >
                  <div className="w-8 h-8 rounded-full bg-white/5 border border-white/10 flex items-center justify-center group-hover:bg-cyan-500/20 group-hover:border-cyan-500/30 transition-all">
                    <Icon name="Plus" className="w-4 h-4 text-white/70 group-hover:text-cyan-400 transition-colors" />
                  </div>
                  <span className="text-[0.65rem] font-bold uppercase tracking-widest text-white/70 group-hover:text-cyan-400 transition-colors">Weiteren Tarif hinzufügen</span>
                </button>
              </div>
            )}

            {calcMode === 'zusatzartikel' && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 animate-in fade-in duration-500">
                <div className="bg-white/[0.02] border border-white/[0.05] rounded-xl p-5 shadow-[inset_0_1px_0_rgba(255,255,255,0.05)]">
                  <h3 className="text-[0.55rem] font-bold text-cyan-400 mb-5 uppercase tracking-[0.2em] flex items-center gap-2">
                    <Icon name="TrendingUp" className="w-3 h-3" /> Provision (erhöht Budget)
                  </h3>
                  <div className="flex flex-col gap-4">
                    <div className="flex items-center justify-between">
                      <label htmlFor="p-n" className="text-xs text-white/80 font-bold">Push (Netto)</label>
                      <div className="relative w-28">
                        <input type="number" step="0.01" min="0" id="p-n" value={activeSession.pushNetto || ''} onChange={(e) => { updateActiveSession({ pushNetto: e.target.value, pushBrutto: '' }); setTrigger(t => t + 1); }} className={`w-full bg-transparent text-base text-white font-black font-mono outline-none text-right pr-4 border-b border-white/10 focus:border-cyan-400 transition-colors pb-1 ${noSpinner}`} placeholder="0.00" />
                        <span className="absolute right-0 top-0.5 text-white/50 font-mono text-sm">€</span>
                      </div>
                    </div>
                    <div className="flex items-center justify-between">
                      <label htmlFor="hwz" className="text-xs text-white/80 font-bold">HW-Zuschuss (Brutto)</label>
                      <div className="relative w-28">
                        <input type="number" step="0.01" min="0" id="hwz" value={activeSession.hardwareZuschussBrutto || ''} onChange={(e) => { updateActiveSession({ hardwareZuschussBrutto: e.target.value }); setTrigger(t => t + 1); }} className={`w-full bg-transparent text-base text-white font-black font-mono outline-none text-right pr-4 border-b border-white/10 focus:border-cyan-400 transition-colors pb-1 ${noSpinner}`} placeholder="0.00" />
                        <span className="absolute right-0 top-0.5 text-white/50 font-mono text-sm">€</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Rechts: Kompakte Zusammenfassung Sidebar */}
        <div className="xl:w-72 shrink-0 bg-black/20 backdrop-blur-2xl border border-white/[0.08] rounded-[1.5rem] p-6 flex flex-col relative overflow-hidden shadow-[inset_0_1px_0_rgba(255,255,255,0.1)]">
          <div className="text-[0.6rem] uppercase tracking-[0.2em] font-bold text-white/70 mb-6 flex items-center gap-2">
            <Icon name="CreditCard" className="w-3 h-3 text-cyan-400" /> Kosten für {activeSession.kundenName || 'Auftrag'}
          </div>
          
          <div className="flex flex-col gap-1 mb-8 relative z-10">
            <span className="text-4xl font-black text-white font-mono tracking-tighter drop-shadow-[0_0_10px_rgba(255,255,255,0.1)]">{fmtEuro(totals?.totalUsed || 0)}</span>
            <span className="text-[0.5rem] uppercase tracking-[0.15em] font-bold text-cyan-500/70">Wird vom Monats-Wallet abgezogen</span>
          </div>

          <div className="space-y-4 relative z-10">
            <div className="flex justify-between items-center text-[0.65rem] font-bold border-b border-white/5 pb-2">
              <span className="text-white/80 uppercase tracking-wider">Hardware</span>
              <span className="text-white font-mono">{fmtEuro(totals?.totalAdBrutto || 0)}</span>
            </div>
            <div className="flex justify-between items-center text-[0.65rem] font-bold border-b border-white/5 pb-2">
              <span className="text-white/80 uppercase tracking-wider">Tarife & Zusatz</span>
              <span className="text-white font-mono">{fmtEuro(totals?.totalMarktBrutto || 0)}</span>
            </div>
            {totals?.totalGetraenkeBrutto > 0 && (
              <div className="flex justify-between items-center text-[0.65rem] font-bold border-b border-white/5 pb-2">
                <span className="text-white/80 uppercase tracking-wider">Getränke</span>
                <span className="text-white font-mono">{fmtEuro(totals?.totalGetraenkeBrutto)}</span>
              </div>
            )}
          </div>
          
          <div className="mt-auto pt-8 relative z-10 flex flex-col gap-3">
            <button onClick={() => { createNewSession(); setCalcMode('smartphone'); setTrigger(t => t + 1); }} className="w-full bg-cyan-500 hover:bg-cyan-400 text-[#0B1120] py-3 rounded-xl text-[0.65rem] font-black uppercase tracking-[0.2em] transition-all shadow-[0_0_15px_rgba(6,182,212,0.3)] flex items-center justify-center gap-2">
              Abschließen <Icon name="CheckCircle2" className="w-3 h-3" />
            </button>
          </div>
        </div>
      </div>

      {/* HARTER ABSTAND UM MARGIN-COLLAPSING ZU VERHINDERN */}
      <div className="w-full h-12 md:h-16 clear-both"></div>

      {/* ========================================== */}
      {/* GETRÄNKE BEREICH WRAPPER                   */}
      {/* ========================================== */}
      <div className="flex flex-col xl:flex-row gap-6 w-full mx-auto relative z-10">
        
        {/* ========================================== */}
        {/* GETRÄNKE / REDBULL EIGENER CONTAINER       */}
        {/* ========================================== */}
        <div className="bg-gradient-to-br from-[#0B1120] to-[#020412] backdrop-blur-3xl border border-white/[0.05] hover:border-amber-500/30 rounded-[2rem] p-6 md:p-8 shadow-[inset_0_1px_0_rgba(255,255,255,0.1),0_15px_30px_-10px_rgba(0,0,0,0.5)] relative z-10 w-full xl:w-[60%] transition-all duration-500 group">
        
        {/* Glow Effect wurde entfernt, da der Kreis störend wirkte */}
        
        {/* Watermark Dose im Hintergrund wurde entfernt */}

        <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-8 relative z-10 border-b border-white/5 pb-4 gap-6">
          <div className="flex items-end gap-6">
            {/* CSS REDBULL DOSE CONTAINER (Overflow-Visible für 3D Effekt) */}
            <div className="relative w-16 h-28 md:w-20 md:h-36 -mt-20 ml-2 group shrink-0 perspective-1000">
              <div className="absolute inset-0 bg-cyan-500/30 rounded-full blur-[30px] group-hover:bg-cyan-400/50 transition-all duration-700"></div>
              <div className="transform rotate-12 group-hover:rotate-0 group-hover:scale-110 group-hover:-translate-y-2 transition-all duration-500 drop-shadow-[0_20px_20px_rgba(0,0,0,0.5)] w-full h-full relative z-10">
                <RedbullCan className="w-full h-full text-[32px]" />
              </div>
            </div>

            <h3 className="text-[0.8rem] md:text-sm font-black text-cyan-400 uppercase tracking-[0.2em] mb-2 drop-shadow-md">
              Getränke / Redbull
            </h3>
          </div>
          {/* Control Center */}
          <div className="flex flex-col xl:flex-row items-stretch xl:items-center justify-between gap-6 mb-4 bg-[#0a1128]/80 backdrop-blur-md border border-cyan-500/20 rounded-[24px] p-5 shadow-[inset_0_2px_10px_rgba(255,255,255,0.05),0_10px_30px_rgba(0,0,0,0.5)] relative overflow-hidden group/ctrl">
            {/* Ambient Background Glow */}
            <div className="absolute top-1/2 left-1/4 -translate-y-1/2 w-32 h-32 bg-cyan-500/10 blur-[40px] rounded-full pointer-events-none group-hover/ctrl:bg-cyan-500/20 transition-all duration-700"></div>

            {/* Left side: Inputs */}
            <div className="flex flex-col gap-3 relative z-10">
              <span className="text-[0.65rem] font-black uppercase tracking-[0.2em] text-cyan-400/80 drop-shadow-sm flex items-center gap-2">
                <Icon name="Settings2" className="w-3.5 h-3.5" />
                Dosenpreis konfigurieren
              </span>
              
              <div className="flex items-center gap-3">
                {/* Netto */}
                <div className="relative flex items-center bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl px-4 py-2.5 shadow-[inset_0_1px_1px_rgba(255,255,255,0.1),0_4px_10px_rgba(0,0,0,0.3)]">
                  <span className="text-[0.55rem] font-bold uppercase tracking-widest text-white/60 mr-3">Netto</span>
                  <span className="text-sm font-black text-white font-mono tracking-wider min-w-[3rem] text-right drop-shadow-md">
                    {defaultRedbullPreis ? (parseFloat(defaultRedbullPreis) / 1.19).toFixed(2) : '0.00'}
                  </span>
                  <span className="text-white/50 font-mono text-[0.65rem] ml-1.5">€</span>
                </div>

                <div className="text-cyan-500/30">
                  <Icon name="ArrowRight" className="w-4 h-4" />
                </div>

                {/* Brutto */}
                <div className="relative flex items-center bg-cyan-500/10 backdrop-blur-xl border border-cyan-500/30 rounded-2xl px-4 py-2.5 shadow-[inset_0_1px_1px_rgba(34,212,238,0.2),0_4px_10px_rgba(0,0,0,0.3)] focus-within:border-cyan-400 focus-within:bg-cyan-500/20 focus-within:shadow-[0_0_20px_rgba(34,212,238,0.2)] transition-all">
                  <span className="text-[0.55rem] font-bold uppercase tracking-widest text-cyan-400/80 mr-3">Brutto</span>
                  <input 
                    type="number" step="0.01" 
                    value={defaultRedbullPreis || ''} 
                    onChange={(e) => { setDefaultRedbullPreis(e.target.value); setTrigger(t => t + 1); }} 
                    className={`w-16 bg-transparent text-sm font-black text-cyan-400 font-mono outline-none text-right tracking-wider drop-shadow-md ${noSpinner}`} 
                    placeholder="2.49" 
                  />
                  <span className="text-cyan-400/50 font-mono text-[0.65rem] ml-1.5">€</span>
                </div>
              </div>
            </div>

            {/* Right side: Buttons */}
            <div className="flex items-center gap-3 w-full xl:w-auto mt-2 xl:mt-0 relative z-10">
              <button onClick={() => { addGetraenk(defaultRedbullPreis); setTrigger(t => t+1); }} className="flex-1 xl:flex-none h-12 px-6 bg-cyan-500/10 border border-cyan-400 hover:bg-cyan-400 text-cyan-400 hover:text-[#0a1128] rounded-2xl flex items-center justify-center gap-2.5 text-[0.65rem] font-black uppercase tracking-[0.15em] transition-all shadow-[0_0_15px_rgba(34,212,238,0.2)] hover:shadow-[0_0_30px_rgba(34,212,238,0.5)] hover:-translate-y-0.5">
                <Icon name="Plus" className="w-4 h-4" /> Standard Dose
              </button>
              <button onClick={() => { addGetraenk(''); setTrigger(t => t+1); }} className="flex-1 xl:flex-none h-12 px-6 border border-dashed border-white/20 hover:border-white/50 hover:bg-white/5 rounded-2xl flex items-center justify-center gap-2 text-white/50 hover:text-white text-[0.65rem] font-black uppercase tracking-[0.15em] transition-all hover:-translate-y-0.5">
                <Icon name="Plus" className="w-4 h-4" /> Individuell
              </button>
            </div>
          </div>
        </div>
        
        <div className="flex flex-col gap-3 w-full relative z-10">
          {(!activeSession.getraenkeList || activeSession.getraenkeList.length === 0) && (
            <div className="py-10 text-center bg-black/20 border border-white/5 rounded-2xl flex flex-col items-center justify-center">
              <div className="w-16 h-16 rounded-full bg-white/5 flex items-center justify-center mb-4 border border-white/10 shadow-inner">
                <Icon name="CupSoda" className="w-8 h-8 text-amber-500/50" />
              </div>
              <h3 className="text-white/40 text-[0.65rem] font-bold uppercase tracking-[0.2em] mb-2 mt-4">Noch keine Getränke erfasst</h3>
              <p className="text-[0.55rem] text-white/20 uppercase tracking-widest">Bitte nutze die Hinzufügen-Buttons im Header.</p>
            </div>
          )}

          {(activeSession.getraenkeList || []).map((getraenk, idx) => (
            <div key={getraenk.id} className="flex flex-col gap-2">
              <div className="bg-white/[0.02] border border-white/5 rounded-2xl p-4 flex flex-col xl:flex-row items-center gap-6 relative group hover:border-amber-500/30 transition-all shadow-inner">
                
                {/* Linke Seite: Name & Icon */}
                <div className="flex items-center gap-4 w-full xl:w-auto xl:flex-1">
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-amber-500/20 to-black/40 border border-amber-500/30 flex items-center justify-center shrink-0 shadow-[0_0_15px_rgba(245,158,11,0.1)]">
                    <Icon name="CupSoda" className="w-6 h-6 text-amber-500 drop-shadow-lg" />
                  </div>
                  <input type="text" value={getraenk.name} onChange={(e) => updateGetraenk(getraenk.id, { name: e.target.value })} className="bg-transparent text-xl font-black text-white outline-none w-full placeholder:text-white/20 focus:text-amber-400 transition-colors" placeholder="Getränk..." />
                </div>

                {/* Mitte: Counter & Preise */}
                <div className="flex items-center gap-4 w-full xl:w-auto justify-between xl:justify-center">
                  
                  {/* Counter */}
                  <div className="flex items-center bg-black/40 border border-white/10 rounded-xl p-1 shadow-inner">
                     <button onClick={() => { updateGetraenk(getraenk.id, { anzahl: Math.max(1, (parseInt(getraenk.anzahl)||1)-1) }); setTrigger(t=>t+1); }} className="w-8 h-8 rounded-lg flex items-center justify-center text-white/40 hover:bg-white/10 hover:text-white transition-colors"><Icon name="Minus" className="w-4 h-4" /></button>
                     <div className="w-10 text-center flex flex-col justify-center">
                       <span className="text-white font-mono font-black text-lg leading-none">{getraenk.anzahl || 1}</span>
                     </div>
                     <button onClick={() => { updateGetraenk(getraenk.id, { anzahl: (parseInt(getraenk.anzahl)||1)+1 }); setTrigger(t=>t+1); }} className="w-8 h-8 rounded-lg flex items-center justify-center text-white/40 hover:bg-white/10 hover:text-white transition-colors"><Icon name="Plus" className="w-4 h-4" /></button>
                  </div>

                  {/* Preise */}
                  <div className="flex items-center gap-2">
                    <div className="relative group/input">
                      <span className="absolute -top-5 left-2 text-[0.5rem] font-bold uppercase tracking-widest text-white/30">Netto</span>
                      <div className="w-24 bg-black/20 border border-white/5 rounded-xl px-3 py-2.5 text-sm font-bold text-white/50 font-mono text-right pr-6 shadow-inner flex items-center justify-end">
                        {getraenk.netto ? getraenk.netto : '0.00'}
                      </div>
                      <span className="absolute right-3 top-1/2 -translate-y-1/2 text-white/20 font-mono text-xs">€</span>
                    </div>
                    <div className="relative group/input">
                      <span className="absolute -top-5 left-2 text-[0.5rem] font-bold uppercase tracking-widest text-amber-400/50 group-focus-within/input:text-amber-400 transition-colors">Brutto</span>
                      <input type="number" step="0.01" min="0" value={getraenk.brutto || ''} onChange={(e) => { 
                        const b = e.target.value; 
                        updateGetraenk(getraenk.id, { brutto: b, netto: b ? (parseFloat(b) / 1.19).toFixed(2) : '' }); 
                        setTrigger(t => t + 1); 
                      }} className={`w-24 bg-amber-500/5 border border-amber-500/20 rounded-xl px-3 py-2.5 text-sm font-black text-amber-400 font-mono outline-none focus:border-amber-400 focus:bg-amber-500/10 text-right pr-6 shadow-inner ${noSpinner}`} placeholder="0.00" />
                      <span className="absolute right-3 top-1/2 -translate-y-1/2 text-amber-400/50 font-mono text-xs">€</span>
                    </div>
                  </div>
                </div>

                {/* Rechte Seite: Checkbox & Delete */}
                <div className="flex items-center justify-between w-full xl:w-auto xl:justify-end gap-6 pl-0 xl:pl-4 xl:border-l border-white/5">
                  <label className="flex items-center gap-3 cursor-pointer group/cb" onClick={() => { updateGetraenk(getraenk.id, { contractSigned: !getraenk.contractSigned }); setTrigger(t => t+1); }}>
                    <div className={`w-6 h-6 rounded-md flex items-center justify-center border transition-all shadow-inner ${getraenk.contractSigned ? 'bg-amber-500 border-amber-400 shadow-[0_0_10px_rgba(245,158,11,0.3)]' : 'bg-black/50 border-white/10 group-hover/cb:border-white/30'}`}>
                      {getraenk.contractSigned && <Icon name="Check" className="w-4 h-4 text-[#0B1120] drop-shadow-md" />}
                    </div>
                    <div className="flex flex-col">
                      <span className={`text-[0.6rem] font-bold uppercase tracking-widest leading-tight ${getraenk.contractSigned ? 'text-amber-400' : 'text-white/50 group-hover/cb:text-white/80'}`}>Vertrag</span>
                      <span className={`text-[0.5rem] font-bold uppercase tracking-widest leading-tight ${getraenk.contractSigned ? 'text-amber-400/70' : 'text-white/30'}`}>entstanden</span>
                    </div>
                  </label>

                  <button onClick={(e) => { 
                      const btn = e.currentTarget;
                      btn.classList.add('bg-emerald-500', 'text-white', 'scale-110', 'shadow-[0_0_20px_rgba(16,185,129,0.6)]');
                      setTimeout(() => btn.classList.remove('bg-emerald-500', 'text-white', 'scale-110', 'shadow-[0_0_20px_rgba(16,185,129,0.6)]'), 500);
                      setTrigger(t=>t+1); 
                    }} 
                    className="w-10 h-10 rounded-xl bg-emerald-500/10 text-emerald-500 hover:bg-emerald-500 hover:text-white hover:shadow-[0_0_15px_rgba(16,185,129,0.4)] flex items-center justify-center transition-all duration-300 border border-emerald-500/20 shrink-0" 
                    title="Eintrag speichern"
                  >
                    <Icon name="Check" className="w-5 h-5" />
                  </button>

                  <button onClick={() => { removeGetraenk(getraenk.id); setTrigger(t=>t+1); }} className="w-10 h-10 rounded-xl bg-rose-500/10 text-rose-500 hover:bg-rose-500 hover:text-white hover:shadow-[0_0_15px_rgba(243,64,121,0.4)] flex items-center justify-center transition-all border border-rose-500/20 shrink-0" title="Eintrag löschen">
                    <Icon name="Trash2" className="w-4 h-4" />
                  </button>
                </div>
              </div>

              {/* === VERTRAGSDETAILS (Wenn Checkbox aktiv) === */}
              {getraenk.contractSigned && (
                <div className="bg-amber-500/5 border border-amber-500/20 rounded-2xl p-4 flex flex-col md:flex-row gap-4 items-center shadow-[inset_0_2px_10px_rgba(0,0,0,0.2)] ml-0 md:ml-12 mb-2 transition-all">
                  <Icon name="Briefcase" className="w-5 h-5 text-amber-500/50 hidden md:block shrink-0" />
                  
                  {/* Suchfeld für Tarife */}
                  <div className="w-full relative group/t">
                     <span className="absolute -top-2 left-3 text-[0.55rem] font-bold uppercase tracking-widest text-amber-500 bg-[#0B1120] px-1 z-10 transition-colors">Zugeordneter Tarif</span>
                     <input 
                       list="tariffs-list" 
                       value={getraenk.contractTariffName || ''} 
                       onChange={(e) => { updateGetraenk(getraenk.id, { contractTariffName: e.target.value }); setTrigger(t=>t+1); }}
                       className="w-full bg-black/40 border border-white/10 group-focus-within/t:border-amber-500 rounded-xl px-4 py-2 text-sm font-medium text-white outline-none transition-colors relative z-0" 
                       placeholder="Suchen oder auswählen..." 
                     />
                  </div>

                  {/* Suchfeld für Optionen */}
                  <div className="w-full relative group/o">
                     <span className="absolute -top-2 left-3 text-[0.55rem] font-bold uppercase tracking-widest text-amber-500/70 bg-[#0B1120] px-1 z-10 transition-colors">Zusatzoption (Optional)</span>
                     <input 
                       list="options-list" 
                       value={getraenk.contractOptionName || ''} 
                       onChange={(e) => { updateGetraenk(getraenk.id, { contractOptionName: e.target.value }); setTrigger(t=>t+1); }}
                       className="w-full bg-black/40 border border-white/10 group-focus-within/o:border-amber-500/50 rounded-xl px-4 py-2 text-sm font-medium text-white outline-none transition-colors relative z-0" 
                       placeholder="Suchen oder auswählen..." 
                     />
                  </div>
                </div>
              )}
            </div>
          ))}



          {/* Native HTML5 Datalists für Dropdowns / Search */}
          <datalist id="tariffs-list">
             {dbTariffs.map(t => <option key={t.id} value={t.title || t.name} />)}
          </datalist>
          <datalist id="options-list">
             {dbOptions.map(o => <option key={o.id} value={o.title || o.name} />)}
          </datalist>
        </div>
      </div>

      {/* ========================================== */}
      {/* REDBULL STATISTIK SIDEBAR                  */}
      {/* ========================================== */}
      <div className="relative w-full xl:w-[40%] flex flex-col group mt-4 xl:mt-0">
          
          {/* Animated Background Mesh Glows */}
          <div className="absolute -right-32 -top-32 w-[500px] h-[500px] bg-gradient-to-br from-cyan-500/20 via-blue-500/10 to-purple-500/20 rounded-full blur-[120px] pointer-events-none group-hover:scale-110 group-hover:from-cyan-400/30 transition-all duration-1000 ease-out z-0"></div>
          <div className="absolute -left-20 bottom-10 w-[400px] h-[400px] bg-gradient-to-tr from-blue-600/20 to-emerald-400/10 rounded-full blur-[100px] pointer-events-none group-hover:scale-110 group-hover:to-emerald-400/20 transition-all duration-1000 ease-out delay-150 z-0"></div>

          {/* Main Glass Panel */}
          <div className="bg-white/[0.02] backdrop-blur-[40px] border border-white/[0.05] rounded-[2.5rem] p-8 md:p-10 shadow-[inset_0_1px_0_rgba(255,255,255,0.1),0_30px_60px_rgba(0,0,0,0.5)] relative z-10 flex flex-col h-full">

            {/* Header */}
            <div className="flex items-center gap-5 mb-10 pb-6 border-b border-white/10">
              <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-cyan-400 to-blue-600 p-[1px] shadow-[0_0_30px_rgba(34,211,238,0.3)] group-hover:shadow-[0_0_40px_rgba(34,211,238,0.5)] transition-shadow duration-500">
                  <div className="w-full h-full bg-[#050B14]/90 backdrop-blur-sm rounded-[15px] flex items-center justify-center">
                    <Icon name="Zap" className="w-6 h-6 text-cyan-400 drop-shadow-[0_0_12px_rgba(34,211,238,0.8)] animate-pulse" />
                  </div>
              </div>
              <h3 className="text-lg md:text-xl font-black text-white uppercase tracking-[0.25em] drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]">
                Redbull Statistik
              </h3>
            </div>

            <div className="flex flex-col gap-5 flex-1">
              
              {/* Box 1: Stückzahl */}
              <div className="bg-white/5 hover:bg-white/10 border border-white/10 hover:border-cyan-400/50 rounded-3xl p-6 flex items-center justify-between transition-all duration-300 shadow-[inset_0_1px_0_rgba(255,255,255,0.05)] hover:-translate-y-1 hover:shadow-[0_10px_30px_rgba(34,211,238,0.1)] group/box relative overflow-hidden">
                  <div className="absolute left-0 top-0 bottom-0 w-1 bg-cyan-400 shadow-[0_0_15px_rgba(34,211,238,0.8)]"></div>
                  <div className="flex flex-col gap-1.5 pl-4">
                    <span className="text-[0.65rem] uppercase tracking-[0.2em] text-cyan-100/80 font-bold group-hover/box:text-cyan-100 transition-colors">Monatlicher</span>
                    <span className="text-sm md:text-base uppercase tracking-[0.15em] text-white font-black drop-shadow-md">Verbrauch</span>
                  </div>
                  <div className="flex items-baseline gap-2">
                    <span className="text-3xl md:text-4xl font-mono font-black text-white drop-shadow-[0_0_15px_rgba(255,255,255,0.4)] tracking-tight">{usedGetraenkeMonatObj.anzahl}</span>
                    <span className="text-xs font-bold text-cyan-100/60 uppercase tracking-widest">Stk.</span>
                  </div>
              </div>

              {/* Box 2: Verträge */}
              <div className="bg-cyan-500/10 hover:bg-cyan-500/20 border border-cyan-400/30 hover:border-cyan-300/60 rounded-3xl p-6 flex items-center justify-between transition-all duration-300 shadow-[inset_0_1px_0_rgba(255,255,255,0.1)] hover:-translate-y-1 hover:shadow-[0_10px_30px_rgba(34,211,238,0.2)] group/box relative overflow-hidden">
                  <div className="absolute left-0 top-0 bottom-0 w-1 bg-cyan-300 shadow-[0_0_20px_rgba(103,232,249,0.8)]"></div>
                  <div className="flex flex-col gap-1.5 pl-4">
                    <span className="text-[0.65rem] uppercase tracking-[0.2em] text-cyan-200/90 font-bold">Daraus resultierende</span>
                    <span className="text-sm md:text-base uppercase tracking-[0.15em] text-cyan-300 font-black drop-shadow-md">Verträge</span>
                  </div>
                  <div className="flex items-baseline gap-2">
                    <span className="text-3xl md:text-4xl font-mono font-black text-cyan-300 drop-shadow-[0_0_15px_rgba(103,232,249,0.6)] tracking-tight">{usedGetraenkeMonatObj.contracts}</span>
                    <span className="text-xs font-bold text-cyan-200/60 uppercase tracking-widest">Stk.</span>
                  </div>
              </div>

              {/* Box 3: Ausgaben / Budget */}
              <div className="bg-white/5 hover:bg-white/10 border border-white/10 hover:border-white/20 rounded-3xl p-6 flex flex-col gap-6 transition-all duration-300 shadow-[inset_0_1px_0_rgba(255,255,255,0.05)] hover:-translate-y-1 group/box relative overflow-hidden">
                  <div className="absolute left-0 top-0 bottom-0 w-1 bg-blue-400 shadow-[0_0_15px_rgba(96,165,250,0.8)]"></div>
                  
                  <div className="flex justify-between items-end pl-4">
                    <span className="text-[0.65rem] uppercase tracking-[0.2em] text-cyan-100/80 font-bold">Belastetes Budget</span>
                    <span className="text-lg md:text-xl font-mono font-black text-white drop-shadow-sm tracking-tight">{fmtEuro(usedGetraenkeMonatObj.brutto)}</span>
                  </div>

                  <div className="w-full bg-black/60 rounded-full h-2.5 overflow-hidden shadow-inner border border-white/5">
                    <div className="h-full rounded-full bg-gradient-to-r from-blue-500 via-cyan-400 to-cyan-300 shadow-[0_0_15px_rgba(34,211,238,0.8)] relative" style={{ width: Math.min(100, Math.max(5, (usedGetraenkeMonatObj.brutto / 500) * 100)) + '%' }}>
                        <div className="absolute right-0 top-0 bottom-0 w-4 bg-white/50 blur-[2px]"></div>
                    </div>
                  </div>

                  <div className="flex justify-between items-end pl-4">
                    <span className="text-[0.6rem] uppercase tracking-[0.2em] text-cyan-200/60 font-bold">Netto-Wert</span>
                    <span className="text-sm font-mono font-bold text-cyan-100">{fmtEuro(usedGetraenkeMonatObj.netto)}</span>
                  </div>
              </div>

              {/* Box 4: Taschenrechner */}
              <div className="bg-[#02060D]/60 border border-white/10 rounded-3xl p-6 flex flex-col gap-5 mt-2 relative overflow-hidden group/calc transition-all hover:border-cyan-400/30">
                 <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/5 to-transparent"></div>
                 
                 <span className="text-[0.65rem] uppercase tracking-[0.2em] text-cyan-100/90 font-bold flex items-center gap-2 relative z-10">
                    <Icon name="Calculator" className="w-4 h-4 text-cyan-400" /> Preis / Dose Kalkulator
                 </span>
                 
                 <div className="flex items-center gap-3 relative z-10">
                    <div className="relative flex-1 bg-white/5 border border-white/10 focus-within:border-cyan-400/60 rounded-2xl px-4 py-3 flex items-center shadow-inner transition-colors">
                      <span className="absolute -top-4 left-2 text-[0.5rem] font-bold uppercase tracking-[0.2em] text-cyan-100/60">Brutto</span>
                      <input 
                        type="number" step="0.01" min="0" 
                        value={doseCalcBrutto} 
                        onChange={(e) => setDoseCalcBrutto(e.target.value)} 
                        className={`w-full bg-transparent border-none text-sm md:text-base font-bold text-white font-mono outline-none text-right shadow-none ${noSpinner}`} 
                        placeholder="0.00" 
                      />
                      <span className="ml-2 text-cyan-100/50 text-xs font-bold">€</span>
                    </div>
                    
                    <Icon name="ArrowRight" className="w-5 h-5 shrink-0 text-cyan-300/50 group-hover/calc:text-cyan-300 transition-colors drop-shadow-[0_0_5px_rgba(34,211,238,0.5)]" />
                    
                    <div className="relative flex-1 bg-gradient-to-br from-cyan-500/20 to-blue-500/10 border border-cyan-400/40 rounded-2xl px-4 py-3 flex items-center justify-end shadow-[inset_0_1px_0_rgba(255,255,255,0.2)]">
                      <span className="absolute -top-4 left-2 text-[0.5rem] font-bold uppercase tracking-[0.2em] text-cyan-300">Netto</span>
                      <span className="text-sm md:text-base font-bold text-white font-mono drop-shadow-md">
                        {doseCalcBrutto ? fmtEuro(parseFloat(doseCalcBrutto) / 1.19).replace('€', '').trim() : '0,00'}
                      </span>
                      <span className="ml-2 text-cyan-300/80 text-xs font-bold">€</span>
                    </div>
                 </div>
                 
                 <button 
                   onClick={() => {
                     if (!doseCalcBrutto || parseFloat(doseCalcBrutto) <= 0) return;
                     const b = parseFloat(doseCalcBrutto).toFixed(2);
                     const n = (parseFloat(doseCalcBrutto) / 1.19).toFixed(2);
                     const list = activeSession.getraenkeList || [];
                     const newGetraenk = { id: Date.now().toString(), name: 'Redbull', anzahl: 1, netto: n, brutto: b, contractSigned: false };
                     updateActiveSession({ getraenkeList: [...list, newGetraenk] });
                     setDoseCalcBrutto('');
                     setTrigger(t => t+1);
                   }}
                   className={`w-full py-3 rounded-xl font-bold text-xs uppercase tracking-widest transition-all flex items-center justify-center gap-2 ${
                     doseCalcBrutto && parseFloat(doseCalcBrutto) > 0 
                     ? 'bg-cyan-500 hover:bg-cyan-400 text-[#02060D] cursor-pointer shadow-[0_0_15px_rgba(34,211,238,0.4)] hover:shadow-[0_0_25px_rgba(34,211,238,0.6)]' 
                     : 'bg-white/5 text-white/30 cursor-not-allowed border border-white/5'
                   }`}
                 >
                   <Icon name="Plus" className="w-4 h-4" /> 
                   <span>In Liste buchen</span>
                 </button>
              </div>

            </div>
            
            <div className="mt-8 text-center relative z-10 border-t border-white/10 pt-6">
              <p className="text-[0.55rem] text-cyan-100/50 uppercase tracking-[0.3em] font-bold">Daten basieren auf allen Berechnungen dieses Kalendermonats.</p>
            </div>
            
          </div>
      </div>

    </div>

      {/* HARTER ABSTAND ZUM LEDGER */}
      <div className="w-full h-20 clear-both"></div>
    </div>
  );

  // ==========================================
  // BOTTOM DASHBOARD (Ledger / Historie)
  // ==========================================
  const renderLedger = () => {
    const sortedSessions = [...(sessions || [])].sort((a,b) => new Date(b?.createdAt || 0) - new Date(a?.createdAt || 0));
    
    return (
      <div className="w-full max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 pb-32">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-3">
            <button onClick={() => setDashboardOffset(prev => prev - 1)} className="p-2 hover:bg-white/5 rounded-full text-white/50 hover:text-white transition-colors"><Icon name="ChevronLeft" className="w-4 h-4" /></button>
            <button onClick={() => setDashboardOffset(0)} className="text-[0.65rem] font-bold uppercase tracking-widest text-cyan-400">Heute</button>
            <button onClick={() => setDashboardOffset(prev => prev + 1)} className="p-2 hover:bg-white/5 rounded-full text-white/50 hover:text-white transition-colors"><Icon name="ChevronRight" className="w-4 h-4" /></button>
          </div>
          <div className="flex items-center gap-2">
            <button onClick={() => setReportModalOpen(true)} className="text-[0.55rem] font-bold uppercase tracking-widest bg-indigo-500/10 text-indigo-400 hover:bg-indigo-500/20 border border-indigo-500/30 px-4 py-2 rounded-full transition-all flex items-center gap-2 shadow-[0_0_15px_rgba(99,102,241,0.2)]">
              <Icon name="Printer" className="w-3 h-3" /> Report PDF
            </button>
            <button onClick={generateTestData} className="text-[0.55rem] font-bold uppercase tracking-widest bg-cyan-500/10 text-cyan-400 hover:bg-cyan-500/20 border border-cyan-500/30 px-4 py-2 rounded-full transition-all flex items-center gap-2">
              <Icon name="Zap" className="w-3 h-3" /> Testdaten Generieren
            </button>
            <button onClick={() => {
              setResetTargetCode(Math.floor(100000 + Math.random() * 900000).toString());
              setResetModalOpen(true);
            }} className="text-[0.55rem] font-bold uppercase tracking-widest bg-pink-500/10 text-pink-400 hover:bg-pink-500/20 border border-pink-500/30 px-4 py-2 rounded-full transition-all flex items-center gap-2">
              <Icon name="Trash2" className="w-3 h-3" /> Reset
            </button>
          </div>
        </div>

        <div className="bg-white/[0.03] backdrop-blur-3xl border border-white/[0.08] rounded-[2rem] overflow-hidden shadow-[inset_0_1px_0_rgba(255,255,255,0.2),0_20px_40px_rgba(0,0,0,0.4)]">
          <div className="grid grid-cols-12 gap-4 px-8 py-5 bg-black/20 border-b border-white/5 text-[0.6rem] font-bold uppercase tracking-[0.2em] text-white/80 backdrop-blur-md">
            <div className="col-span-3">Datum</div>
            <div className="col-span-4">Kunde / Aktion</div>
            <div className="col-span-3 text-right">Betrag</div>
            <div className="col-span-2 text-right">Aktionen</div>
          </div>

          <div className="divide-y divide-white/5 max-h-[400px] overflow-y-auto">
            {sortedSessions.map(s => {
              const sessionTotal = calculateSessionTotal ? calculateSessionTotal(s) : 0;
              const isActive = s.id === activeSessionId;
              
              return (
                <div key={s.id} className={`grid grid-cols-12 gap-4 px-8 py-5 items-center transition-colors ${isActive ? 'bg-cyan-500/10' : 'hover:bg-white/[0.04]'}`}>
                  <div className="col-span-3 text-xs text-white/70 font-mono">
                    {s.createdAt ? new Date(s.createdAt).toLocaleString('de-DE', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : 'Unbekannt'}
                  </div>
                  <div className="col-span-4 flex items-center gap-4">
                    <div className={`w-8 h-8 rounded-full flex items-center justify-center border ${isActive ? 'bg-cyan-500/20 border-cyan-500/30 text-cyan-400 shadow-[0_0_10px_rgba(6,182,212,0.5)]' : 'bg-black/30 border-white/10 text-white/60'}`}>
                      {isActive ? <Icon name="Activity" className="w-3 h-3" /> : <Icon name="User" className="w-3 h-3" />}
                    </div>
                    <div>
                      <div className={`text-sm font-bold tracking-wide ${isActive ? 'text-cyan-400' : 'text-white'}`}>{s.name || 'Ohne Name'}</div>
                      <div className="flex items-center gap-2 mt-1">
                        {isActive && <span className="text-[0.55rem] text-cyan-500/70 uppercase tracking-widest bg-cyan-500/10 px-2 py-0.5 rounded-sm">Aktive Bearbeitung</span>}
                        {s.contractSigned && <span className="text-[0.55rem] text-emerald-400 uppercase tracking-widest bg-emerald-500/10 px-2 py-0.5 rounded-sm flex items-center gap-1"><Icon name="Check" className="w-2 h-2" /> Vertrag</span>}
                      </div>
                    </div>
                  </div>
                  <div className="col-span-3 text-right">
                    <span className={`text-sm font-black font-mono ${sessionTotal > 0 ? 'text-rose-400' : 'text-white/60'}`}>
                      {sessionTotal > 0 ? '-' : ''}{fmtEuro(Math.abs(sessionTotal))}
                    </span>
                  </div>
                  <div className="col-span-2 flex justify-end gap-2">
                    {!isActive && (
                      <button onClick={(e) => { e.stopPropagation(); switchSession(s.id); }} className="bg-white/5 hover:bg-white/10 border border-white/10 text-white/80 hover:text-white px-4 py-2 rounded-lg text-[0.6rem] font-bold uppercase tracking-widest transition-all">
                        Öffnen
                      </button>
                    )}
                    <button onClick={(e) => { 
                      e.stopPropagation(); 
                      setSessionToDelete(s.id); 
                      setResetTargetCode(Math.floor(100000 + Math.random() * 900000).toString());
                      setResetCode('');
                    }} className="text-white/50 hover:text-rose-400 p-2 transition-colors relative z-20">
                      <Icon name="Trash2" className="w-4 h-4 pointer-events-none" />
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  // ==========================================
  // DELETE MODAL (Lightbox)
  // ==========================================
  useEffect(() => {
    // Auto-Submit für Lösch-Modal (sessionToDelete)
    if (sessionToDelete && resetCode.length === 6) {
      if (resetCode === resetTargetCode) {
        deleteSession(sessionToDelete);
        setTrigger(t => t + 1);
        setSessionToDelete(null);
        setResetCode('');
        
        // Zwinge einen UI Reload, um Sync-Probleme zu umgehen
        setTimeout(() => {
            window.location.reload();
        }, 300);
      } else {
        setIsShaking(true);
        setTimeout(() => {
          setIsShaking(false);
          setResetCode('');
          setResetTargetCode(Math.floor(100000 + Math.random() * 900000).toString());
        }, 500);
      }
    }
    
    // Auto-Submit für "Alles Reset" Modal (resetModalOpen)
    if (resetModalOpen && resetCode.length === 6) {
      if (resetCode === resetTargetCode) {
        const allSessions = useSpielgeldStore.getState().sessions;
        // Asynchron alle Sessions aus der Datenbank löschen
        allSessions.forEach(s => deleteSession(s.id));
        
        setResetModalOpen(false);
        setResetCode('');
        
        // 500ms warten, damit die DB Requests durch sind, dann Reload (init erzeugt eine leere neue Session)
        setTimeout(() => {
            window.location.reload();
        }, 500);
      } else {
        setIsShaking(true);
        setTimeout(() => {
          setIsShaking(false);
          setResetCode('');
          setResetTargetCode(Math.floor(100000 + Math.random() * 900000).toString());
        }, 500);
      }
    }
  }, [resetCode, sessionToDelete, resetModalOpen, resetTargetCode, deleteSession]);

  const renderDeleteModal = () => {
    if (!sessionToDelete) return null;
    return (
      <div className="fixed inset-0 flex items-center justify-center p-4" style={{ zIndex: 9999 }}>
        <style>{`
          @keyframes shake {
            0%, 100% { transform: translateX(0); }
            20%, 60% { transform: translateX(-10px); }
            40%, 80% { transform: translateX(10px); }
          }
          .shake-animation { animation: shake 0.4s cubic-bezier(.36,.07,.19,.97) both; }
        `}</style>
        <div className="absolute inset-0 bg-black/80 backdrop-blur-md animate-in fade-in duration-300 cursor-pointer" onClick={() => { setSessionToDelete(null); setResetCode(''); }}></div>
        <div className={`relative w-full max-w-sm bg-[#0B1120]/95 backdrop-blur-xl rounded-3xl overflow-hidden animate-in zoom-in-95 duration-300 text-center p-8 ${isShaking ? 'shake-animation' : ''}`} style={{ border: '1px solid rgba(255,0,255,0.3)', boxShadow: '0 0 50px rgba(255,0,255,0.2)' }}>
          <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6" style={{ background: 'rgba(255,0,255,0.1)', border: '1px solid rgba(255,0,255,0.3)', boxShadow: 'inset 0 0 20px rgba(255,0,255,0.3)' }}>
            <Icon name="AlertTriangle" className="w-8 h-8" style={{ color: '#ff00ff', filter: 'drop-shadow(0 0 10px rgba(255,0,255,0.8))' }} />
          </div>
          <h3 className="text-white font-bold text-xl mb-2">Berechnung löschen?</h3>
          <p className="text-white/50 text-sm mb-6">Bitte gib den folgenden 6-stelligen Code ein, um die Berechnung permanent zu löschen:</p>
          
          <div className={`bg-black/50 p-4 rounded-xl border ${isShaking ? 'border-red-500' : 'border-white/10'} mb-6 flex flex-col gap-3 transition-colors`}>
            <span className="text-2xl font-mono font-bold tracking-[0.25em]" style={{ color: '#ff00ff', textShadow: '0 0 10px rgba(255,0,255,0.5)' }}>{resetTargetCode}</span>
            <input 
              type="text" 
              maxLength="6"
              autoFocus
              value={resetCode} 
              onChange={e => {
                const val = e.target.value.replace(/[^0-9]/g, '');
                setResetCode(val);
              }} 
              placeholder="000000"
              className={`w-full text-center bg-[#0B1120] text-white rounded-lg p-3 text-2xl font-mono tracking-[0.5em] outline-none transition-colors ${isShaking ? 'border-red-500 text-red-400' : 'border-white/20 focus:border-pink-500'}`}
              style={{ border: '1px solid' }}
            />
          </div>

          <div className="flex flex-col gap-3">
            <button 
              onClick={(e) => { e.stopPropagation(); setSessionToDelete(null); setResetCode(''); }} 
              className="w-full py-4 bg-white/5 hover:bg-white/10 text-white/70 hover:text-white font-bold rounded-xl transition-all border border-white/5"
            >
              Abbrechen
            </button>
          </div>
        </div>
      </div>
    );
  };

  // ==========================================
  // RESET MODAL (Lightbox)
  // ==========================================
  const renderResetModal = () => {
    if (!resetModalOpen) return null;
    
    const isCodeCorrect = resetCode.toUpperCase() === resetTargetCode;

    return (
      <div className="fixed inset-0 flex items-center justify-center p-4" style={{ zIndex: 9999 }}>
        <div className="absolute inset-0 bg-black/80 backdrop-blur-md animate-in fade-in duration-300 cursor-pointer" onClick={() => { setResetModalOpen(false); setResetCode(''); }}></div>
        <div className="relative w-full max-w-sm rounded-3xl overflow-hidden animate-in zoom-in-95 duration-300 text-center p-8 shadow-[0_0_80px_rgba(255,0,255,0.3)]" style={{ background: 'linear-gradient(135deg, #2e003e 0%, #4a004a 100%)', border: '1px solid #ff00ff' }}>
          <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6" style={{ background: '#000000', border: '2px solid #ff00ff', boxShadow: '0 0 20px rgba(255,0,255,0.6)' }}>
            <Icon name="AlertTriangle" className="w-8 h-8" style={{ color: '#ffffff' }} />
          </div>
          <h3 className="text-white font-bold text-2xl mb-2">Alle Daten löschen?</h3>
          <p className="text-white/80 text-sm mb-6">Dies löscht alle Berechnungen und Einstellungen. Willst du wirklich bei Null anfangen?</p>
          
          <div className="mb-8">
            <label className="block text-[0.6rem] font-bold uppercase tracking-widest text-[#ff00ff] mb-2">Sicherheitsabfrage</label>
            <input 
              type="text" 
              placeholder={`GIB '${resetTargetCode}' EIN...`}
              value={resetCode}
              onChange={(e) => setResetCode(e.target.value)}
              className="w-full bg-black/50 border border-[#ff00ff]/50 rounded-xl px-4 py-3 text-center text-white font-mono text-xl tracking-widest outline-none focus:border-[#ff00ff] focus:bg-black/80 transition-all uppercase placeholder-white/30"
            />
          </div>

          <div className="flex flex-col gap-3">
            <button 
              disabled={!isCodeCorrect}
              onClick={() => {
                localStorage.removeItem('tef-spielgeld-v4-storage');
                window.location.reload();
              }} 
              className="w-full py-4 text-white font-bold rounded-xl transition-all disabled:opacity-30 disabled:cursor-not-allowed"
              style={{ backgroundColor: isCodeCorrect ? '#ff00ff' : 'rgba(0,0,0,0.5)', border: isCodeCorrect ? 'none' : '1px solid rgba(255,0,255,0.3)', boxShadow: isCodeCorrect ? '0 0 30px rgba(255,0,255,0.8)' : 'none' }}
            >
              Ja, alles löschen
            </button>
            <button 
              onClick={() => { setResetModalOpen(false); setResetCode(''); }} 
              className="w-full py-4 bg-black/30 hover:bg-black/50 text-white/70 hover:text-white font-bold rounded-xl transition-all border border-white/10"
            >
              Abbrechen
            </button>
          </div>
        </div>
      </div>
    );
  };

  // ==========================================
  // SETTINGS MODAL (Lightbox)
  // ==========================================
  const renderSettingsModal = () => {
    if (!isSettingsOpen) return null;
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        {/* Backdrop */}
        <div 
          className="absolute inset-0 bg-black/60 backdrop-blur-md animate-in fade-in duration-300 cursor-pointer" 
          onClick={() => setIsSettingsOpen(false)}
        ></div>
        
        {/* Modal Container */}
        <div className="relative w-full max-w-xl bg-gradient-to-br from-[#0019A5]/95 via-[#000d6b]/95 to-[#000531]/95 backdrop-blur-xl border border-white/10 rounded-3xl shadow-[0_0_50px_rgba(0,0,0,0.5)] overflow-hidden animate-in zoom-in-95 duration-300">
          
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-white/5 bg-black/20">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-cyan-500/10 border border-cyan-500/20 flex items-center justify-center">
                <Icon name="Settings" className="w-5 h-5 text-cyan-400" />
              </div>
              <div>
                <h3 className="text-white font-bold text-lg tracking-wide">Budget Konfiguration</h3>
                <p className="text-slate-500 text-[0.65rem] uppercase tracking-widest">Monats-Wallet verwalten</p>
              </div>
            </div>
            <button 
              onClick={() => { setIsSettingsOpen(false); localStorage.setItem('isSettingsOpen', 'false'); }}
              className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-white/5 text-slate-500 hover:text-white transition-colors"
            >
              <Icon name="X" className="w-5 h-5" />
            </button>
          </div>

          <div className="p-8 space-y-8">
            
            {/* Basis-Budget */}
            <div>
              <label className="text-[0.65rem] uppercase tracking-[0.2em] text-cyan-400 font-bold mb-3 flex items-center gap-2">
                <Icon name="Wallet" className="w-3.5 h-3.5" /> Basis-Budget
              </label>
              
              <div className="flex flex-col gap-2">
                <div className="flex justify-between items-center bg-black/20 border border-white/10 rounded-2xl px-5 py-4 focus-within:border-cyan-400/50 transition-colors">
                  <span className="text-xs font-bold uppercase tracking-widest text-cyan-400">Netto</span>
                  <div className="flex items-center gap-2 w-1/2">
                    <input
                      type="number" step="0.01"
                      value={globalBudget || ''}
                      onChange={(e) => { setGlobalBudget(e.target.value); setTrigger(t => t + 1); }}
                      className={`w-full bg-transparent text-xl font-black text-cyan-400 font-mono outline-none text-right tracking-wider placeholder-cyan-900/50 ${noSpinner}`}
                      placeholder="0.00"
                    />
                    <span className="text-cyan-400 font-mono text-xl">€</span>
                  </div>
                </div>
                
                <div className="flex justify-between items-center bg-black/40 border border-transparent rounded-2xl px-5 py-3">
                  <span className="text-xs font-bold uppercase tracking-widest text-slate-500">Brutto</span>
                  <div className="flex items-center gap-2 w-1/2 justify-end">
                    <div className="text-lg font-black text-slate-400 font-mono text-right tracking-wider">
                      {globalBudget ? (parseFloat(globalBudget) * 1.19).toFixed(2) : '0.00'}
                    </div>
                    <span className="text-slate-500 font-mono text-lg">€</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="h-px w-full bg-white/5"></div>

            {/* Top Up Budget */}
            <div>
              <label className="text-[0.65rem] uppercase tracking-[0.2em] text-pink-400 font-bold mb-3 flex items-center gap-2">
                <Icon name="TrendingUp" className="w-3.5 h-3.5" /> Erweiterungs-Option (Top-Up)
              </label>
              
              <div className="flex flex-col gap-2">
                <div className="flex gap-2">
                  <input
                    type="text"
                    value={tempTopUpDesc}
                    onChange={(e) => setTempTopUpDesc(e.target.value)}
                    className="flex-1 bg-black/20 border border-white/10 rounded-2xl px-5 py-4 text-sm font-bold text-white outline-none focus:border-pink-400/50 transition-colors"
                    placeholder="Grund (z.B. Sonderfreigabe)"
                  />
                  
                  <div className="flex justify-between items-center bg-black/20 border border-white/10 rounded-2xl px-4 py-4 focus-within:border-pink-400/50 transition-colors w-32 sm:w-44">
                    <input
                      type="number" step="0.01"
                      value={tempTopUpAmount}
                      onChange={(e) => setTempTopUpAmount(e.target.value)}
                      className={`w-full bg-transparent text-lg font-black text-pink-400 font-mono outline-none text-right tracking-wider placeholder-pink-900/50 ${noSpinner}`}
                      placeholder="0.00"
                    />
                    <span className="text-pink-400 font-mono text-lg ml-2">€</span>
                  </div>

                  <button 
                    onClick={() => {
                      if (tempTopUpAmount) {
                        addTopUp(tempTopUpAmount, tempTopUpDesc || 'Zusatz-Budget');
                        setTempTopUpAmount('');
                        setTempTopUpDesc('');
                        setTrigger(t => t+1);
                      }
                    }}
                    className="bg-pink-500 hover:bg-pink-400 text-white w-14 rounded-2xl font-bold transition-all flex items-center justify-center shrink-0"
                  >
                    <Icon name="Plus" className="w-5 h-5" />
                  </button>
                </div>

                <div className="flex justify-end w-full">
                  <div className="flex justify-between items-center bg-black/40 border border-transparent rounded-2xl px-5 py-3 w-[12rem] sm:w-[15rem]">
                    <span className="text-xs font-bold uppercase tracking-widest text-slate-500">Brutto</span>
                    <div className="flex items-center gap-2 justify-end">
                      <div className="text-sm font-black text-slate-400 font-mono text-right tracking-wider">
                        {tempTopUpAmount ? (parseFloat(tempTopUpAmount) * 1.19).toFixed(2) : '0.00'}
                      </div>
                      <span className="text-slate-500 font-mono text-sm">€</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Aktive TopUps Liste */}
              {topUps.length > 0 && (
                <div className="mt-6 space-y-2">
                  {topUps.map(t => (
                    <div key={t.id} className="flex justify-between items-center bg-white/5 border border-white/10 rounded-2xl px-5 py-4">
                      <div>
                        <div className="text-sm font-bold text-pink-400">{t.description}</div>
                        <div className="text-[0.65rem] text-slate-400 uppercase tracking-wider">{new Date(t.date).toLocaleDateString()}</div>
                      </div>
                      <div className="flex items-center gap-4">
                        <div className="flex flex-col items-end">
                          <span className="text-[0.55rem] font-bold text-white/30 uppercase tracking-widest">Brutto</span>
                          <div className="font-mono text-xs font-black text-white/70">+{fmtEuro(parseFloat(t.amount) * 1.19)}</div>
                        </div>
                        <button onClick={() => { removeTopUp(t.id); setTrigger(t => t+1); }} className="text-slate-500 hover:text-red-400 ml-2">
                          <Icon name="Trash2" className="w-4 h-4" />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

          </div>
        </div>
      </div>
    );
  };

  // ==========================================
  // HELPER: Dashboard Date Range Calculation
  // ==========================================
  const getDashboardDateInfo = () => {
    const now = new Date();
    let title = '';
    let start = new Date(now);
    let end = new Date(now);

    if (dashboardFilter === 'TAG') {
      start.setDate(now.getDate() + dashboardOffset);
      start.setHours(0,0,0,0);
      end = new Date(start);
      end.setHours(23,59,59,999);
      title = start.toLocaleDateString('de-DE');
      if (dashboardOffset === 0) title = 'Heute';
      else if (dashboardOffset === -1) title = 'Gestern';
    } 
    else if (dashboardFilter === 'KALENDERWOCHE') {
      const day = now.getDay() || 7; 
      start.setHours(0,0,0,0);
      start.setDate(now.getDate() - day + 1 + (dashboardOffset * 7));
      end = new Date(start);
      end.setDate(start.getDate() + 6);
      end.setHours(23,59,59,999);
      
      const d = new Date(Date.UTC(start.getFullYear(), start.getMonth(), start.getDate()));
      d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay()||7));
      const yearStart = new Date(Date.UTC(d.getUTCFullYear(),0,1));
      const weekNo = Math.ceil((((d - yearStart) / 86400000) + 1)/7);
      
      title = dashboardOffset === 0 ? 'Diese Woche' : `KW ${weekNo} / ${start.getFullYear()}`;
    }
    else if (dashboardFilter === 'MONAT') {
      start.setMonth(now.getMonth() + dashboardOffset);
      start.setDate(1);
      start.setHours(0,0,0,0);
      end = new Date(start);
      end.setMonth(start.getMonth() + 1);
      end.setDate(0);
      end.setHours(23,59,59,999);
      const months = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
      title = dashboardOffset === 0 ? 'Dieser Monat' : `${months[start.getMonth()]} ${start.getFullYear()}`;
    }
    else if (dashboardFilter === 'JAHR') {
      start.setFullYear(now.getFullYear() + dashboardOffset);
      start.setMonth(0, 1);
      start.setHours(0,0,0,0);
      end = new Date(start);
      end.setFullYear(start.getFullYear() + 1);
      end.setMonth(0, 0);
      end.setHours(23,59,59,999);
      title = dashboardOffset === 0 ? 'Dieses Jahr' : `${start.getFullYear()}`;
    }

    return { title, start, end };
  };

  // ==========================================
  // CHART MODAL (DONUT STATS LIGHTBOX)
  // ==========================================
  const renderChartModal = () => {
    if (!chartModalOpen) return null;

    const { title, start, end } = getDashboardDateInfo();
    const filteredForBox = sessions.filter(s => {
      const d = new Date(s.createdAt);
      return d >= start && d <= end;
    });

    const totalUsed = Object.values(monthlyBudgets).reduce((sum, b) => sum + (b.totalAdBrutto || 0) + (b.totalMarktBrutto || 0), 0);
    const hasData = totalUsed > 0;
    
    // Neue Aufteilung nach Nutzerwunsch
    const hardwareRatio = hasData ? 0.65 : 0;
    const tariffRatio = hasData ? 0.25 : 0;
    const zusatzRatio = hasData ? 0.05 : 0;
    const drinksRatio = hasData ? 0.05 : 0;

    // Radius und Umfang für das große SVG Chart
    const circ = 2 * Math.PI * 120;
    const hardLen = circ * hardwareRatio;
    const tariffLen = circ * tariffRatio;
    const zusatzLen = circ * zusatzRatio;
    const drinksLen = circ * drinksRatio;
    
    // Offsets für die Segmente (wir starten bei 0 und rotieren um -90deg per CSS)
    const hardOffset = 0;
    const tariffOffset = -hardLen;
    const zusatzOffset = -(hardLen + tariffLen);
    const drinksOffset = -(hardLen + tariffLen + zusatzLen);

    return (
      <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 sm:p-8">
        {/* Fullscreen Backdrop mit extremem Blur & Bubbles */}
        <div 
          className="absolute inset-0 bg-gradient-to-br from-[#0025D1]/60 via-[#0019A5]/70 to-[#000531]/80 backdrop-blur-3xl animate-in fade-in duration-500 cursor-pointer" 
          onClick={() => setChartModalOpen(false)}
        >
          {/* Große O2 Background Lichtkreise */}
          <div className="absolute top-[-10%] left-[-10%] w-[50vw] h-[50vw] rounded-full bg-blue-500/20 blur-[100px] pointer-events-none"></div>
          <div className="absolute bottom-[-10%] right-[-10%] w-[60vw] h-[60vw] rounded-full bg-cyan-400/10 blur-[120px] pointer-events-none"></div>

          {/* Animated O2 Bubbles im Backdrop */}
          <div className="absolute inset-0 pointer-events-none z-0">
            <div className="o2-bg-bubble" style={{ width: '120px', height: '120px', left: '10%', animationDuration: '18s', animationDelay: '0s' }}></div>
            <div className="o2-bg-bubble" style={{ width: '200px', height: '200px', left: '80%', animationDuration: '22s', animationDelay: '3s' }}></div>
            <div className="o2-bg-bubble" style={{ width: '80px', height: '80px', left: '40%', animationDuration: '14s', animationDelay: '7s' }}></div>
            <div className="o2-bg-bubble" style={{ width: '150px', height: '150px', left: '60%', animationDuration: '25s', animationDelay: '1s' }}></div>
            <div className="o2-bg-bubble" style={{ width: '90px', height: '90px', left: '25%', animationDuration: '16s', animationDelay: '9s' }}></div>
            <div className="o2-bg-bubble" style={{ width: '110px', height: '110px', left: '70%', animationDuration: '19s', animationDelay: '12s' }}></div>
          </div>
        </div>
        
        {/* Modal Container */}
        <div className="relative z-10 w-full max-w-4xl bg-gradient-to-br from-[#020412]/80 to-[#000005]/90 backdrop-blur-2xl border border-white/10 shadow-[0_0_80px_rgba(0,30,160,0.3)] rounded-3xl overflow-hidden animate-in zoom-in-95 duration-500 flex flex-col">
          
          {/* Header */}
          <div className="flex items-center justify-between p-6 md:px-8 border-b border-white/10 bg-white/5 backdrop-blur-md relative overflow-hidden shrink-0 z-10">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-500 via-cyan-400 to-blue-500"></div>
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-full bg-cyan-500/10 border border-cyan-500/30 flex items-center justify-center shadow-[0_0_15px_rgba(6,182,212,0.2)]">
                <Icon name="PieChart" className="w-6 h-6 text-cyan-400" />
              </div>
              <div>
                <h3 className="text-white font-black text-xl tracking-wider uppercase flex items-center gap-3">
                  <button onClick={() => setDashboardOffset(o => o - 1)} className="hover:text-cyan-400 p-1 transition-colors">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
                  </button>
                  {title}
                  <button onClick={() => setDashboardOffset(o => o + 1)} disabled={dashboardOffset >= 0} className={`p-1 transition-colors ${dashboardOffset >= 0 ? 'text-white/20 cursor-not-allowed' : 'hover:text-cyan-400'}`}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
                  </button>
                </h3>
                <p className="text-cyan-500/80 text-[0.65rem] font-bold uppercase tracking-[0.2em]">Budget-Aufteilung</p>
              </div>
            </div>
            <button 
              onClick={() => setChartModalOpen(false)}
              className="w-10 h-10 flex items-center justify-center rounded-full bg-white/5 hover:bg-rose-500/20 text-slate-400 hover:text-rose-500 transition-colors"
            >
              <Icon name="X" className="w-5 h-5" />
            </button>
          </div>

          {/* Content */}
          <div className="p-8 md:p-12 flex flex-col md:flex-row items-center justify-center gap-12 relative z-10">
            <div className="absolute inset-0 bg-gradient-to-b from-white/5 to-transparent pointer-events-none"></div>

            {/* Großes animiertes Donut Chart */}
            <div className="relative w-64 h-64 md:w-80 md:h-80 flex-shrink-0">
              <div className="absolute inset-0 rounded-full bg-cyan-500/5 blur-3xl"></div>
              
              <svg viewBox="0 0 300 300" className="w-full h-full relative z-10 drop-shadow-2xl">
                <circle cx="150" cy="150" r="120" fill="none" stroke="rgba(255,255,255,0.02)" strokeWidth="20" />
                {/* Hardware */}
                <circle 
                  cx="150" cy="150" r="120" 
                  fill="none" stroke="currentColor" strokeWidth="20" 
                  className="text-cyan-400 drop-shadow-[0_0_12px_rgba(34,211,238,0.6)]" 
                  strokeDasharray={`${hardLen} ${circ}`} strokeDashoffset={0} 
                  strokeLinecap="round" transform="rotate(-90 150 150)"
                />
                {/* Tarife */}
                <circle 
                  cx="150" cy="150" r="120" 
                  fill="none" stroke="currentColor" strokeWidth="20" 
                  className="text-emerald-400 drop-shadow-[0_0_12px_rgba(52,211,153,0.6)]" 
                  strokeDasharray={`${tariffLen} ${circ}`} strokeDashoffset={-hardLen} 
                  strokeLinecap="round" transform="rotate(-90 150 150)"
                />
                {/* Zusatz */}
                <circle 
                  cx="150" cy="150" r="120" 
                  fill="none" stroke="currentColor" strokeWidth="20" 
                  className="text-purple-500 drop-shadow-[0_0_12px_rgba(168,85,247,0.6)]" 
                  strokeDasharray={`${zusatzLen} ${circ}`} strokeDashoffset={-(hardLen + tariffLen)} 
                  strokeLinecap="round" transform="rotate(-90 150 150)"
                />
                {/* Getränke */}
                <circle 
                  cx="150" cy="150" r="120" 
                  fill="none" stroke="currentColor" strokeWidth="20" 
                  className="text-amber-400 drop-shadow-[0_0_12px_rgba(251,191,36,0.6)]" 
                  strokeDasharray={`${drinksLen} ${circ}`} strokeDashoffset={-(hardLen + tariffLen + zusatzLen)} 
                  strokeLinecap="round" transform="rotate(-90 150 150)"
                />
              </svg>
              
              <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
                <span className="text-[0.65rem] font-bold text-slate-400 uppercase tracking-[0.2em] mb-1">Ausgegeben</span>
                <span className="text-3xl font-black font-mono text-white tracking-tighter">{fmtEuro(totalUsed)}</span>
              </div>
            </div>

            {/* Legende */}
            <div className="flex flex-col gap-6 w-full md:w-auto z-10">
              <div className="bg-white/[0.03] backdrop-blur-md border border-white/[0.05] rounded-2xl p-5 flex items-center gap-5">
                <div className="w-3 h-3 rounded-full bg-cyan-400 shadow-[0_0_8px_rgba(34,211,238,0.8)]"></div>
                <div className="flex-1">
                  <div className="text-[0.65rem] font-bold uppercase tracking-widest text-white/60 mb-0.5">Hardware & Zubehör</div>
                  <div className="text-sm font-black font-mono text-cyan-400">{fmtEuro(totalUsed * hardwareRatio)}</div>
                </div>
              </div>
              <div className="bg-white/[0.03] backdrop-blur-md border border-white/[0.05] rounded-2xl p-5 flex items-center gap-5">
                <div className="w-3 h-3 rounded-full bg-emerald-400 shadow-[0_0_8px_rgba(52,211,153,0.8)]"></div>
                <div className="flex-1">
                  <div className="text-[0.65rem] font-bold uppercase tracking-widest text-white/60 mb-0.5">Tarife & Optionen</div>
                  <div className="text-sm font-black font-mono text-emerald-400">{fmtEuro(totalUsed * tariffRatio)}</div>
                </div>
              </div>
              <div className="bg-white/[0.03] backdrop-blur-md border border-white/[0.05] rounded-2xl p-5 flex items-center gap-5">
                <div className="w-3 h-3 rounded-full bg-purple-500 shadow-[0_0_8px_rgba(168,85,247,0.8)]"></div>
                <div className="flex-1">
                  <div className="text-[0.65rem] font-bold uppercase tracking-widest text-white/60 mb-0.5">Zusatzartikel</div>
                  <div className="text-sm font-black font-mono text-purple-400">{fmtEuro(totalUsed * zusatzRatio)}</div>
                </div>
              </div>
              <div className="bg-white/[0.03] backdrop-blur-md border border-white/[0.05] rounded-2xl p-5 flex items-center gap-5">
                <div className="w-3 h-3 rounded-full bg-amber-400 shadow-[0_0_8px_rgba(251,191,36,0.8)]"></div>
                <div className="flex-1">
                  <div className="text-[0.65rem] font-bold uppercase tracking-widest text-white/60 mb-0.5">Getränke / Redbull</div>
                  <div className="text-sm font-black font-mono text-amber-400">{fmtEuro(totalUsed * drinksRatio)}</div>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    );
  };

  // ==========================================
  // REPORT MODAL (PDF / Druck)
  // ==========================================
  const renderReportModal = () => {
    if (!reportModalOpen) return null;
    
    // Logik für Filter
    const now = new Date();
    let start = new Date(now);
    let end = new Date(now);
    
    if (reportFilter === 'HEUTE') {
      start.setHours(0,0,0,0);
      end.setHours(23,59,59,999);
    } else if (reportFilter === 'WOCHE') {
      const day = now.getDay() || 7; 
      start.setDate(now.getDate() - day + 1);
      start.setHours(0,0,0,0);
      end = new Date(start);
      end.setDate(start.getDate() + 6);
      end.setHours(23,59,59,999);
    } else if (reportFilter === 'MONAT') {
      start.setDate(1);
      start.setHours(0,0,0,0);
      end.setMonth(start.getMonth() + 1, 0);
      end.setHours(23,59,59,999);
    } else {
      // ALLE
      start = new Date('2000-01-01');
    }

    const filtered = sessions.filter(s => {
      const d = new Date(s.createdAt);
      return d >= start && d <= end;
    }).sort((a,b) => new Date(b?.createdAt || 0) - new Date(a?.createdAt || 0));

    const totalUsed = filtered.reduce((sum, s) => sum + (calculateSessionTotal ? calculateSessionTotal(s) : 0), 0);

    return (
      <div className="fixed inset-0 z-[10000] flex flex-col items-center p-4 sm:p-8 bg-black/90 backdrop-blur-xl overflow-y-auto print:bg-white print:p-0 print:block">
        
        {/* Toolbar (wird beim Drucken ausgeblendet) */}
        <div className="w-full max-w-[210mm] flex items-center justify-between mb-6 print:hidden shrink-0 animate-in slide-in-from-top-4 duration-500">
          <div className="flex items-center gap-4">
            <h2 className="text-white font-bold text-xl flex items-center gap-2"><Icon name="Printer" className="w-5 h-5 text-indigo-400" /> Export Preview</h2>
            <select 
              value={reportFilter} 
              onChange={(e) => setReportFilter(e.target.value)}
              className="bg-white/10 border border-white/20 text-white text-sm font-bold tracking-wide rounded-lg px-3 py-1.5 outline-none hover:bg-white/20 transition-colors"
            >
              <option value="HEUTE" className="text-black">Heute</option>
              <option value="WOCHE" className="text-black">Diese Woche</option>
              <option value="MONAT" className="text-black">Dieser Monat</option>
              <option value="ALLE" className="text-black">Alle Daten</option>
            </select>
          </div>
          <div className="flex items-center gap-3">
            <button onClick={() => window.print()} className="bg-indigo-600 hover:bg-indigo-500 text-white px-6 py-2 rounded-xl font-bold transition-all shadow-[0_0_20px_rgba(99,102,241,0.4)] flex items-center gap-2">
              <Icon name="Printer" className="w-4 h-4" /> PDF Drucken
            </button>
            <button onClick={() => setReportModalOpen(false)} className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 text-white transition-all">
              <Icon name="X" className="w-5 h-5" />
            </button>
          </div>
        </div>

        {/* Das echte A4 Blatt */}
        <div id="print-section" className="w-full max-w-[210mm] min-h-[297mm] bg-white text-black p-10 sm:p-16 shadow-[0_0_50px_rgba(0,0,0,0.5)] shrink-0 print:shadow-none print:w-auto print:max-w-none print:min-h-0 print:p-0 animate-in zoom-in-95 duration-500">
          
          {/* Header */}
          <div className="flex justify-between items-end border-b-2 border-slate-200 pb-6 mb-8">
            <div>
              <div className="flex items-center gap-3 mb-2">
                <div className="w-8 h-8 rounded-full bg-indigo-600 flex items-center justify-center">
                  <Icon name="Activity" className="w-4 h-4 text-white" />
                </div>
                <h1 className="text-2xl font-black tracking-tight text-slate-900">O2 BUDGET REPORT</h1>
              </div>
              <p className="text-slate-500 font-medium mt-2 uppercase tracking-widest text-[0.65rem]">
                Zeitraum: <strong className="text-indigo-600">{reportFilter}</strong> ({start.toLocaleDateString('de-DE')} - {reportFilter==='HEUTE' ? start.toLocaleDateString('de-DE') : end.toLocaleDateString('de-DE')})
              </p>
            </div>
            <div className="text-right">
              <p className="text-slate-400 text-[0.6rem] font-bold uppercase tracking-widest mb-1">Erstellt am</p>
              <p className="text-slate-800 font-mono text-sm">{new Date().toLocaleString('de-DE')}</p>
            </div>
          </div>

          {/* Übersicht */}
          <div className="flex gap-8 mb-10 p-6 bg-slate-50 rounded-2xl border border-slate-100">
            <div>
              <p className="text-slate-400 text-[0.6rem] font-bold uppercase tracking-widest mb-1">Vorgänge</p>
              <p className="text-2xl font-black text-slate-800">{filtered.length}</p>
            </div>
            <div className="w-px bg-slate-200"></div>
            <div>
              <p className="text-slate-400 text-[0.6rem] font-bold uppercase tracking-widest mb-1">Belastetes Gesamtbudget</p>
              <p className="text-2xl font-black text-indigo-600 font-mono">{fmtEuro(totalUsed)}</p>
            </div>
          </div>

          {/* Tabelle */}
          <div className="mb-10">
            <h3 className="text-[0.65rem] font-bold uppercase tracking-widest text-slate-800 mb-4 border-b border-slate-200 pb-2">Detailauswertung</h3>
            <table className="w-full text-left text-sm">
              <thead>
                <tr className="text-[0.6rem] uppercase tracking-widest text-slate-400 border-b border-slate-200">
                  <th className="pb-3 font-bold">Datum</th>
                  <th className="pb-3 font-bold">Kunde / Bemerkung</th>
                  <th className="pb-3 font-bold text-right">Hardware</th>
                  <th className="pb-3 font-bold text-right">Tarife</th>
                  <th className="pb-3 font-bold text-right">Getränke</th>
                  <th className="pb-3 font-bold text-right">Gesamt</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {filtered.map(s => {
                  const sTotal = calculateSessionTotal ? calculateSessionTotal(s) : 0;
                  
                  // Detail Summierung
                  let hW = 0; s.articles?.forEach(a => hW += (a.inputMode==='brutto'?parseFloat(a.preis||0):(parseFloat(a.preis||0)*1.19)));
                  hW += parseFloat(s.hardwareZuschussBrutto||0);
                  
                  let tW = 0; s.tariffs?.forEach(t => tW += (parseFloat(t.couponBrutto||0) + parseFloat(t.couponErhohungBrutto||0)));
                  tW += parseFloat(s.pushBrutto||0) || (parseFloat(s.pushNetto||0)*1.19);
                  
                  let gW = 0; s.getraenkeList?.forEach(g => gW += (parseFloat(g.brutto||0) || (parseFloat(g.netto||0)*1.19)));
                  gW += parseFloat(s.redbullNetto||0)*1.19 + (parseFloat(s.getraenkeBrutto||0) || (parseFloat(s.getraenkeNetto||0)*1.19));

                  return (
                    <tr key={s.id} className="text-slate-600">
                      <td className="py-3 font-mono text-xs">{new Date(s.createdAt).toLocaleString('de-DE', {day:'2-digit',month:'2-digit',hour:'2-digit',minute:'2-digit'})}</td>
                      <td className="py-3 font-medium text-slate-800 text-[0.8rem]">{s.name || 'Leere Berechnung'} {s.contractSigned && <span className="text-[0.5rem] bg-emerald-100 text-emerald-600 px-1 py-0.5 rounded ml-2 uppercase font-bold tracking-wider">Vertrag</span>}</td>
                      <td className="py-3 font-mono text-xs text-right text-slate-500">{hW > 0 ? fmtEuro(hW) : '-'}</td>
                      <td className="py-3 font-mono text-xs text-right text-slate-500">{tW > 0 ? fmtEuro(tW) : '-'}</td>
                      <td className="py-3 font-mono text-xs text-right text-slate-500">{gW > 0 ? fmtEuro(gW) : '-'}</td>
                      <td className="py-3 font-mono text-[0.8rem] text-right font-black text-indigo-600">{fmtEuro(sTotal)}</td>
                    </tr>
                  );
                })}
                {filtered.length === 0 && (
                  <tr>
                    <td colSpan="6" className="py-8 text-center text-slate-400 italic text-sm">Keine Berechnungen in diesem Zeitraum gefunden.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Unterschrift */}
          <div className="mt-32 flex justify-between px-10">
            <div className="w-48 border-t border-slate-300 pt-2 text-center">
              <p className="text-[0.6rem] uppercase tracking-widest text-slate-400 font-bold">Unterschrift Außendienst</p>
            </div>
            <div className="w-48 border-t border-slate-300 pt-2 text-center">
              <p className="text-[0.6rem] uppercase tracking-widest text-slate-400 font-bold">Unterschrift Markt-Verantwortlicher</p>
            </div>
          </div>
          
        </div>
      </div>
    );
  };

  // ==========================================
  // DASHBOARD MODAL (STATISTICS LIGHTBOX)
  // ==========================================
  const renderDashboardModal = () => {
    if (!dashboardOpen) return null;

    const { title, start, end } = getDashboardDateInfo();
    const filteredForBox = sessions.filter(s => {
      const d = new Date(s.createdAt);
      return d >= start && d <= end;
    }).sort((a,b) => new Date(b?.createdAt || 0) - new Date(a?.createdAt || 0));

    const totalForBox = filteredForBox.reduce((sum, s) => sum + (calculateSessionTotal ? calculateSessionTotal(s) : 0), 0);
    const transactionCount = filteredForBox.length;
    const hasData = totalForBox > 0;
    
    // Berechne Ratios für das Dashboard
    const hardwareRatio = hasData ? 0.65 : 0;
    const tariffRatio = hasData ? 0.25 : 0;
    const zusatzRatio = hasData ? 0.05 : 0;
    const drinksRatio = hasData ? 0.05 : 0;

    return (
      <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 sm:p-8">
        {/* Fullscreen Backdrop mit extremem Blur & Bubbles */}
        <div 
          className="absolute inset-0 bg-gradient-to-br from-[#0025D1]/60 via-[#0019A5]/70 to-[#000531]/80 backdrop-blur-3xl animate-in fade-in duration-500 cursor-pointer" 
          onClick={() => setDashboardOpen(false)}
        >
          {/* Große O2 Background Lichtkreise */}
          <div className="absolute top-[-10%] left-[-10%] w-[50vw] h-[50vw] rounded-full bg-blue-500/20 blur-[100px] pointer-events-none"></div>
          <div className="absolute bottom-[-10%] right-[-10%] w-[60vw] h-[60vw] rounded-full bg-cyan-400/10 blur-[120px] pointer-events-none"></div>

          {/* Animated O2 Bubbles im Backdrop */}
          <div className="absolute inset-0 pointer-events-none z-0">
            <div className="o2-bg-bubble" style={{ width: '120px', height: '120px', left: '10%', animationDuration: '18s', animationDelay: '0s' }}></div>
            <div className="o2-bg-bubble" style={{ width: '200px', height: '200px', left: '80%', animationDuration: '22s', animationDelay: '3s' }}></div>
            <div className="o2-bg-bubble" style={{ width: '80px', height: '80px', left: '40%', animationDuration: '14s', animationDelay: '7s' }}></div>
            <div className="o2-bg-bubble" style={{ width: '150px', height: '150px', left: '60%', animationDuration: '25s', animationDelay: '1s' }}></div>
            <div className="o2-bg-bubble" style={{ width: '90px', height: '90px', left: '25%', animationDuration: '16s', animationDelay: '9s' }}></div>
            <div className="o2-bg-bubble" style={{ width: '110px', height: '110px', left: '70%', animationDuration: '19s', animationDelay: '12s' }}></div>
          </div>
        </div>
        
        {/* Modal Container */}
        <div className="relative z-10 w-full max-w-6xl bg-gradient-to-br from-[#020412]/80 to-[#000005]/90 backdrop-blur-2xl border border-white/10 shadow-[0_0_80px_rgba(0,30,160,0.3)] rounded-3xl overflow-hidden animate-in zoom-in-95 duration-300 flex flex-col max-h-[90vh]">
          
          {/* Header */}
          <div className="flex items-center justify-between p-6 md:px-8 border-b border-white/10 bg-white/5 backdrop-blur-md relative overflow-hidden shrink-0 z-10">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-cyan-500 to-blue-600"></div>
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-full bg-cyan-500/10 border border-cyan-500/30 flex items-center justify-center shadow-[0_0_15px_rgba(6,182,212,0.2)]">
                <Icon name="Activity" className="w-6 h-6 text-cyan-400" />
              </div>
              <div>
                <h3 className="text-white font-black text-xl tracking-wider uppercase flex items-center gap-3">
                  <button onClick={() => setDashboardOffset(o => o - 1)} className="hover:text-cyan-400 p-1 transition-colors">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
                  </button>
                  {title}
                  <button onClick={() => setDashboardOffset(o => o + 1)} disabled={dashboardOffset >= 0} className={`p-1 transition-colors ${dashboardOffset >= 0 ? 'text-white/20 cursor-not-allowed' : 'hover:text-cyan-400'}`}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
                  </button>
                </h3>
                <p className="text-cyan-500/80 text-[0.65rem] font-bold uppercase tracking-[0.2em]">Auswertung Dashboard</p>
              </div>
            </div>
            <div className="flex items-center gap-6">
              <button 
                onClick={() => setDashboardOpen(false)}
                className="w-10 h-10 flex items-center justify-center rounded-full bg-white/5 hover:bg-rose-500/20 text-slate-400 hover:text-rose-500 transition-colors"
              >
                <Icon name="X" className="w-5 h-5" />
              </button>
            </div>
          </div>

          {/* Scrollbarer Content */}
          <div className="p-6 md:p-8 overflow-y-auto hide-scrollbar flex-1 relative z-10">
            <div className="absolute inset-0 bg-gradient-to-b from-white/5 to-transparent pointer-events-none"></div>

            {/* METRICS CARDS */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10 relative z-10">
              <div className="bg-white/[0.03] backdrop-blur-3xl border border-white/[0.08] rounded-3xl p-6 shadow-[inset_0_1px_0_rgba(255,255,255,0.2)]">
                <div className="text-[0.65rem] font-bold uppercase tracking-[0.2em] text-white/60 mb-2 flex items-center gap-2">
                  <Icon name="TrendingUp" className="w-4 h-4 text-rose-400" /> Gesamtausgaben
                </div>
                <div className="text-3xl md:text-4xl font-black font-mono text-white mb-2">{fmtEuro(totalForBox)}</div>
                <div className="text-[0.65rem] font-bold uppercase tracking-widest text-rose-400/80">Netto berechnet</div>
              </div>

              <div className="bg-white/[0.03] backdrop-blur-3xl border border-white/[0.08] rounded-3xl p-6 shadow-[inset_0_1px_0_rgba(255,255,255,0.2)]">
                <div className="text-[0.65rem] font-bold uppercase tracking-[0.2em] text-white/60 mb-2 flex items-center gap-2">
                  <Icon name="ShoppingBag" className="w-4 h-4 text-cyan-400" /> Transaktionen
                </div>
                <div className="text-3xl md:text-4xl font-black font-mono text-white mb-2">{transactionCount}</div>
                <div className="text-[0.65rem] font-bold uppercase tracking-widest text-cyan-400/80">In diesem Zeitraum</div>
              </div>

              <div className="bg-white/[0.03] backdrop-blur-3xl border border-white/[0.08] rounded-3xl p-6 shadow-[inset_0_1px_0_rgba(255,255,255,0.2)]">
                <div className="text-[0.65rem] font-bold uppercase tracking-[0.2em] text-white/60 mb-2 flex items-center gap-2">
                  <Icon name="Activity" className="w-4 h-4 text-emerald-400" /> Ø Pro Buchung
                </div>
                <div className="text-3xl md:text-4xl font-black font-mono text-white mb-2">{fmtEuro(transactionCount > 0 ? totalForBox / transactionCount : 0)}</div>
                <div className="text-[0.65rem] font-bold uppercase tracking-widest text-emerald-400/80">Durchschnittswert</div>
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 relative z-10">
              {/* CHART SECTION */}
              <div className="bg-white/[0.03] backdrop-blur-3xl border border-white/[0.08] rounded-3xl p-6 shadow-[inset_0_1px_0_rgba(255,255,255,0.2)]">
                <h3 className="text-xs font-bold text-white tracking-[0.1em] uppercase mb-6 flex items-center gap-2">
                  <Icon name="Percent" className="w-4 h-4 text-cyan-400" /> Verteilung der Ausgaben
                </h3>
                
                <div className="space-y-5">
                  <div>
                    <div className="flex justify-between text-[0.65rem] font-bold uppercase tracking-widest text-white/80 mb-2">
                      <span>Hardware & Zubehör</span>
                      <span className="font-mono text-cyan-400">{fmtEuro(totalForBox * hardwareRatio)}</span>
                    </div>
                    <div className="w-full h-2.5 bg-black/40 rounded-full overflow-hidden border border-white/5 relative">
                      <div className="absolute top-0 bottom-0 left-0 bg-cyan-400 rounded-full transition-all duration-1000 ease-out" style={{ width: `${hardwareRatio * 100}%` }}></div>
                    </div>
                  </div>

                  <div>
                    <div className="flex justify-between text-[0.65rem] font-bold uppercase tracking-widest text-white/80 mb-2">
                      <span>Tarife & Optionen</span>
                      <span className="font-mono text-emerald-400">{fmtEuro(totalForBox * tariffRatio)}</span>
                    </div>
                    <div className="w-full h-2.5 bg-black/40 rounded-full overflow-hidden border border-white/5 relative">
                      <div className="absolute top-0 bottom-0 left-0 bg-emerald-400 rounded-full transition-all duration-1000 ease-out" style={{ width: `${tariffRatio * 100}%` }}></div>
                    </div>
                  </div>

                  <div>
                    <div className="flex justify-between text-[0.65rem] font-bold uppercase tracking-widest text-white/80 mb-2">
                      <span>Zusatzartikel</span>
                      <span className="font-mono text-purple-500">{fmtEuro(totalForBox * zusatzRatio)}</span>
                    </div>
                    <div className="w-full h-2.5 bg-black/40 rounded-full overflow-hidden border border-white/5 relative">
                      <div className="absolute top-0 bottom-0 left-0 bg-purple-500 rounded-full transition-all duration-1000 ease-out" style={{ width: `${zusatzRatio * 100}%` }}></div>
                    </div>
                  </div>

                  <div>
                    <div className="flex justify-between text-[0.65rem] font-bold uppercase tracking-widest text-white/80 mb-2">
                      <span>Getränke / Redbull</span>
                      <span className="font-mono text-amber-400">{fmtEuro(totalForBox * drinksRatio)}</span>
                    </div>
                    <div className="w-full h-2.5 bg-black/40 rounded-full overflow-hidden border border-white/5 relative">
                      <div className="absolute top-0 bottom-0 left-0 bg-amber-400 rounded-full transition-all duration-1000 ease-out" style={{ width: `${drinksRatio * 100}%` }}></div>
                    </div>
                  </div>
                </div>
              </div>

              {/* TRANSACTIONS TABLE */}
              <div className="bg-white/[0.03] backdrop-blur-3xl border border-white/[0.08] rounded-3xl p-6 shadow-[inset_0_1px_0_rgba(255,255,255,0.2)] flex flex-col">
                <h3 className="text-xs font-bold text-white tracking-[0.1em] uppercase mb-4 flex items-center gap-2">
                  <Icon name="History" className="w-4 h-4 text-cyan-400" /> Buchungen
                </h3>
                
                <div className="flex-1 overflow-y-auto pr-2" style={{ maxHeight: '250px' }}>
                  {filteredForBox.length === 0 ? (
                    <div className="text-center py-10 opacity-50">
                      <p className="text-white font-bold text-sm">Keine Transaktionen</p>
                    </div>
                  ) : (
                    <div className="space-y-2">
                      {filteredForBox.map(s => {
                        const sTotal = calculateSessionTotal ? calculateSessionTotal(s) : 0;
                        return (
                          <div key={s.id} className="flex justify-between items-center p-3 rounded-xl bg-black/20 hover:bg-white/5 border border-white/5 transition-colors group cursor-pointer" onClick={() => { setDashboardOpen(false); switchSession(s.id); }}>
                            <div className="flex items-center gap-3">
                              <div className="w-8 h-8 rounded-full bg-cyan-500/10 text-cyan-400 flex items-center justify-center border border-cyan-500/20 group-hover:bg-cyan-500 group-hover:text-[#0a0f19] transition-all">
                                <Icon name="User" className="w-3.5 h-3.5" />
                              </div>
                              <div>
                                <div className="text-xs font-bold text-white">{s.name || 'Ohne Name'}</div>
                                <div className="text-[0.6rem] text-white/50">{s.createdAt ? new Date(s.createdAt).toLocaleString('de-DE', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : 'Unbekannt'}</div>
                              </div>
                            </div>
                            <span className={`text-sm font-black font-mono ${sTotal > 0 ? 'text-rose-400' : 'text-white/80'}`}>
                              {sTotal > 0 ? '-' : ''}{fmtEuro(Math.abs(sTotal))}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>

            </div>
          </div>
          
        </div>
      </div>
    );
  };

  // ==========================================
  // CALENDAR MODAL (SPATIAL UI DATE PICKER)
  // ==========================================
  const renderCalendarModal = () => {
    if (!calendarOpen) return null;

    const baseDate = new Date();
    baseDate.setMonth(baseDate.getMonth() + calendarMonthOffset);
    const month = baseDate.getMonth();
    const year = baseDate.getFullYear();

    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const firstDay = new Date(year, month, 1).getDay(); 
    const startOffset = firstDay === 0 ? 6 : firstDay - 1;

    const days = [];
    for (let i = 0; i < startOffset; i++) days.push(null);
    for (let i = 1; i <= daysInMonth; i++) days.push(i);

    const monthName = baseDate.toLocaleDateString('de-DE', { month: 'long', year: 'numeric' });

    const handleSelectDate = (d) => {
      const newDate = new Date(year, month, d);
      setRechnerDate(newDate);
      setCalendarOpen(false);
    };

    return (
      <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 sm:p-8">
        {/* Fullscreen Backdrop mit extremem Blur & Bubbles */}
        <div 
          className="absolute inset-0 bg-gradient-to-br from-[#0025D1]/60 via-[#0019A5]/70 to-[#000531]/80 backdrop-blur-3xl animate-in fade-in duration-500 cursor-pointer" 
          onClick={() => setCalendarOpen(false)}
        >
          {/* Große O2 Background Lichtkreise */}
          <div className="absolute top-[-10%] left-[-10%] w-[50vw] h-[50vw] rounded-full bg-blue-500/20 blur-[100px] pointer-events-none"></div>
          <div className="absolute bottom-[-10%] right-[-10%] w-[60vw] h-[60vw] rounded-full bg-cyan-400/10 blur-[120px] pointer-events-none"></div>

          {/* Animated O2 Bubbles im Backdrop */}
          <div className="absolute inset-0 pointer-events-none z-0">
            <div className="o2-bg-bubble" style={{ width: '120px', height: '120px', left: '10%', animationDuration: '18s', animationDelay: '0s' }}></div>
            <div className="o2-bg-bubble" style={{ width: '200px', height: '200px', left: '80%', animationDuration: '22s', animationDelay: '3s' }}></div>
            <div className="o2-bg-bubble" style={{ width: '80px', height: '80px', left: '40%', animationDuration: '14s', animationDelay: '7s' }}></div>
            <div className="o2-bg-bubble" style={{ width: '150px', height: '150px', left: '60%', animationDuration: '25s', animationDelay: '1s' }}></div>
            <div className="o2-bg-bubble" style={{ width: '90px', height: '90px', left: '25%', animationDuration: '16s', animationDelay: '9s' }}></div>
            <div className="o2-bg-bubble" style={{ width: '110px', height: '110px', left: '70%', animationDuration: '19s', animationDelay: '12s' }}></div>
          </div>
        </div>
        
        {/* Modal Container */}
        <div className="relative z-10 w-full max-w-sm bg-gradient-to-br from-[#020412]/80 to-[#000005]/90 backdrop-blur-2xl border border-white/10 shadow-[0_0_80px_rgba(0,30,160,0.3)] rounded-[2rem] overflow-hidden animate-in zoom-in-95 duration-500">
          
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-white/10 bg-white/5 backdrop-blur-md relative">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-cyan-400 via-blue-500 to-cyan-400"></div>
            <button onClick={() => setCalendarMonthOffset(o => o - 1)} className="p-2 text-white/50 hover:text-cyan-400 transition-colors">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
            </button>
            <div className="text-white font-black tracking-wider uppercase text-lg text-center flex-1 drop-shadow-[0_0_8px_rgba(255,255,255,0.3)]">{monthName}</div>
            <button onClick={() => setCalendarMonthOffset(o => o + 1)} className="p-2 text-white/50 hover:text-cyan-400 transition-colors">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
            </button>
          </div>

          {/* Grid */}
          <div className="p-6 relative">
            <div className="absolute inset-0 bg-cyan-500/5 blur-2xl pointer-events-none"></div>
            
            <div className="grid grid-cols-7 gap-2 mb-4 relative z-10">
              {['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'].map(d => (
                <div key={d} className="text-center text-[0.6rem] font-bold uppercase text-cyan-500/80 tracking-widest">{d}</div>
              ))}
            </div>

            <div className="grid grid-cols-7 gap-2 relative z-10">
              {days.map((d, i) => {
                if (!d) return <div key={`empty-${i}`} className="w-8 h-8 md:w-10 md:h-10"></div>;
                
                const isSelected = rechnerDate.getDate() === d && rechnerDate.getMonth() === month && rechnerDate.getFullYear() === year;
                const isToday = new Date().getDate() === d && new Date().getMonth() === month && new Date().getFullYear() === year;
                
                return (
                  <button
                    key={`day-${d}`}
                    onClick={() => handleSelectDate(d)}
                    className={`w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full text-sm font-bold transition-all duration-300 relative group
                      ${isSelected ? 'bg-cyan-500 text-[#05080c] shadow-[0_0_20px_rgba(6,182,212,0.8)] scale-110 z-10' : 
                        isToday ? 'bg-white/10 text-white border border-white/20 hover:bg-white/20' : 
                        'text-slate-300 hover:bg-cyan-500/20 hover:text-cyan-300 hover:shadow-[0_0_15px_rgba(6,182,212,0.3)]'}`}
                  >
                    {d}
                  </button>
                );
              })}
            </div>
          </div>
          
          <div className="p-4 bg-[#030609] border-t border-white/5 flex justify-center">
             <button onClick={() => { setRechnerDate(new Date()); setCalendarMonthOffset(0); setCalendarOpen(false); }} className="text-[0.6rem] font-bold uppercase tracking-[0.2em] text-slate-500 hover:text-cyan-400 transition-colors">Zurück auf Heute</button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={`bg-gradient-to-br from-[#0019A5] via-[#000d6b] to-[#000531] text-slate-300 font-sans tracking-tight selection:bg-cyan-500/30 overflow-x-hidden relative flex flex-col ${isStandalone ? 'min-h-screen' : 'rounded-2xl shadow-xl'}`} style={isStandalone ? { paddingTop: 'calc(var(--header-height, 155px) + 64px)' } : {}}>
      <div className="absolute top-[-5%] left-[10%] w-[50%] h-[50%] bg-white/10 blur-[100px] rounded-full pointer-events-none mix-blend-overlay" />
      <div className="fixed top-[20%] right-[-10%] w-[40%] h-[60%] bg-cyan-400/20 blur-[120px] rounded-full pointer-events-none mix-blend-screen" />
      <div className="fixed bottom-[-10%] left-[25%] w-[40%] h-[40%] bg-blue-400/20 blur-[100px] rounded-full pointer-events-none mix-blend-screen" />
      <div className="fixed inset-0 opacity-[0.03] pointer-events-none mix-blend-overlay" style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=%220 0 200 200%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cfilter id=%22noiseFilter%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.65%22 numOctaves=%223%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23noiseFilter)%22/%3E%3C/svg%3E")' }} />

      <style>{`
        @keyframes floatBubble {
          0% { top: 120%; transform: scale(0.6); opacity: 0; }
          20% { opacity: 0.3; }
          80% { opacity: 0.3; }
          100% { top: -20%; transform: scale(1.1); opacity: 0; }
        }
        .o2-bg-bubble {
          position: absolute;
          top: 120%;
          opacity: 0;
          border-radius: 50%;
          border: 1px solid rgba(255, 255, 255, 0.4);
          background: radial-gradient(circle at 30% 30%, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.02) 60%, transparent 80%);
          box-shadow: inset 0 0 20px rgba(255, 255, 255, 0.1), 0 0 15px rgba(0, 0, 0, 0.2);
          animation: floatBubble 15s infinite linear;
          animation-fill-mode: both;
          pointer-events: none;
          backdrop-filter: blur(2px);
        }
        @media print {
          body * {
            visibility: hidden;
          }
          #print-section, #print-section * {
            visibility: visible;
          }
          #print-section {
            position: absolute;
            left: 0;
            top: 0;
            width: 100% !important;
            margin: 0 !important;
            padding: 0 !important;
            background: white !important;
            color: black !important;
            box-shadow: none !important;
          }
          @page {
            margin: 1cm;
            size: A4 portrait;
          }
        }
      `}</style>

      {renderWalletDashboard()}
      {renderRechnerView()}
      {renderLedger()}

      {renderSettingsModal()}
      {renderDeleteModal()}
      {renderResetModal()}
      {renderDashboardModal()}
      {renderChartModal()}
      {renderCalendarModal()}
      {renderReportModal()}
    </div>
  );
}
